export const getSingleTimelineData = () => {
	return [
		{
			"id": 575,
			"user_id": 11062,
			"clinic_id": 1,
			"type": "thighs",
			"doctor_name": "Praveen Provider Soni",
			"patient_id": 192,
			"procedure_name": "20200521 005",
			"procedure_date": "2020-05-20 12:03:00",
			"procedure_image": "1590051331_idw1Jfl0MvI.jpg",
			"procedure_image_45": "1590051309_yG_kRzUtajU.jpg",
			"consent_ids": "187,188",
			"note": null,
			"count_flag": null,
			"status": 0,
			"added_from": "",
			"edited_from": "",
			"created": "2020-05-20 12:04:20",
			"modified": "2020-05-21 14:26:28",
			"md_signed": 0,
			"md_signature": null,
			"appointment_id": 0,
			"service_id": 0,
			"invoice_id": 0,
			"sent_to_md": 0,
			"md_user_id": 0,
			"provider_signature": null,
			"provider_signed": 0,
			"save_status": "final",
			"is_consult": 0,
			"is_after_photos": 0,
			"procedure_type": "cosmetic",
			"consultation_fee": 0,
			"procedure_template_id": 0,
			"is_hidden": 0,
			"md_signed_on": "0000-00-00 00:00:00",
			"provider_signed_on": "0000-00-00 00:00:00",
			"after_photos_available": 1,
			"template_used": 1,
			"chief_complaint": null,
			"answers_count": 0,
			"answer_multiples_count": 0,
			"total_price": 70,
			"product_data": [{
				"product_name": "Botox 100 Units\/vial",
				"quantity": 2,
				"unit": "Cycles",
				"product_id": 3196,
				"procedure_id": 575,
				"category_id": "462",
				"price": 50
			}, {
				"product_name": "Acne Treatment Lotion 2 Oz Nfr",
				"quantity": 1,
				"unit": "Units",
				"product_id": 3288,
				"procedure_id": 575,
				"category_id": "319",
				"price": 20
			}],
			"injection_array": [{
				"product_name": "Botox 100 Units\/vial",
				"quantity": 2,
				"unit": "Cycles",
				"product_id": 3196,
				"procedure_id": 575,
				"price": 50
			}, {
				"product_name": "Acne Treatment Lotion 2 Oz Nfr",
				"quantity": 1,
				"unit": "Units",
				"product_id": 3288,
				"procedure_id": 575,
				"price": 20
			}],
			"total_tax": 0,
			"injections": [{
				"id": 497,
				"procedure_id": 575,
				"product_name": "Botox 100 Units\/vial",
				"quantity": 2,
				"product_id": 3196,
				"product": {
					"id": 3196,
					"toxin_type": "5",
					"price": 0,
					"category_id": "462",
					"product_image_url": ""
				}
			}, {
				"id": 498,
				"procedure_id": 575,
				"product_name": "Acne Treatment Lotion 2 Oz Nfr",
				"quantity": 1,
				"product_id": 3288,
				"product": {
					"id": 3288,
					"toxin_type": "1",
					"price": 0,
					"category_id": "319",
					"product_image_url": ""
				}
			}, {
				"id": 499,
				"procedure_id": 575,
				"product_name": "Botox 100 Units\/vial",
				"quantity": "1.0",
				"product_id": 3196,
				"product": {
					"id": 3196,
					"toxin_type": "5",
					"price": 0,
					"category_id": "462",
					"product_image_url": ""
				}
			}, {
				"id": 500,
				"procedure_id": 575,
				"product_name": "Botox 100 Units\/vial",
				"quantity": "0.5",
				"product_id": 3196,
				"product": {
					"id": 3196,
					"toxin_type": "5",
					"price": 0,
					"category_id": "462",
					"product_image_url": ""
				}
			}, {
				"id": 501,
				"procedure_id": 575,
				"product_name": "Acne Treatment Lotion 2 Oz Nfr",
				"quantity": "0.5",
				"product_id": 3288,
				"product": {
					"id": 3288,
					"toxin_type": "1",
					"price": 0,
					"category_id": "319",
					"product_image_url": ""
				}
			}],
			"total_image_count": 3,
			"combined_image": "https:\/\/devapi.aestheticrecord.com\/api\/combined-procedure-image\/1937.575.1590051392.jpeg?next=2",
			"combined_image_45": "https:\/\/devapi.aestheticrecord.com\/api\/combined-procedure-image\/1937.575.1590051392.jpeg?next=1",
			"survey_appointment_id": null,
			"ba_videos_available": 0,
			"consent_data": [{
				"id": 187,
				"consent_id": 6,
				"signature_image_url": "",
				"signature_thumb_image_url": "",
				"witness_signature_url": "",
				"witness_signature_thumb_image_url": "",
				"created_format_date": "0000-00-00 00:00:00",
				"consent": {
					"id": 6,
					"consent_name": "000 AAA PS First Consent",
					"consent_small_description": null,
					"consent_large_description": "Vel facilisis volutpat est velit egestas dui id. Nunc sed blandit libero volutpat sed cras ornare arcu dui. Id cursus metus aliquam eleifend mi in. Egestas quis ipsum suspendisse ultrices gravida. Duis at consectetur lorem donec massa sapien. Velit euismod in pellentesque massa placerat. Purus viverra accumsan in nisl nisi scelerisque eu. Nunc congue nisi vitae suscipit tellus mauris. Facilisi nullam vehicula ipsum a arcu cursus. Et ultrices neque ornare aenean euismod elementum.\n\n\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vel fringilla est ullamcorper eget nulla facilisi etiam. Non consectetur a erat nam at lectus urna. Nisl pretium fusce id velit ut tortor pretium viverra suspendisse. Consectetur adipiscing elit duis tristique sollicitudin nibh sit. Ullamcorper velit sed ullamcorper morbi tincidunt ornare massa eget egestas. Mauris commodo quis imperdiet massa tincidunt nunc pulvinar sapien et. Dignissim diam quis enim lobortis scelerisque fermentum dui faucibus. Pulvinar sapien et ligula ullamcorper malesuada proin libero nunc consequat. Tristique magna sit amet purus. Eu augue ut lectus arcu bibendum at varius. Tristique magna sit amet purus gravida. Sed odio morbi quis commodo odio aenean sed adipiscing diam. Amet facilisis magna etiam tempor orci eu. Tellus in metus vulputate eu scelerisque felis imperdiet. Odio morbi quis commodo odio. Dictumst quisque sagittis purus sit amet volutpat consequat mauris nunc.\n\n\n\nVel pretium lectus quam id leo in. At ultrices mi tempus imperdiet nulla. Amet porttitor eget dolor morbi. Ligula ullamcorper malesuada proin libero nunc consequat interdum. Purus ut faucibus pulvinar elementum integer enim neque. Vel pharetra vel turpis nunc eget. Eget mauris pharetra et ultrices neque ornare aenean euismod. Neque aliquam vestibulum morbi blandit. Ut diam quam nulla porttitor massa. Pretium aenean pharetra magna ac placerat vestibulum. Suspendisse interdum consectetur libero id. Fermentum et sollicitudin ac orci phasellus egestas tellus rutrum. Eu augue ut lectus arcu bibendum. Integer eget aliquet nibh praesent tristique magna sit. Tellus cras adipiscing enim eu turpis egestas.\n\n\n\n\n\nAuctor augue mauris augue neque gravida in fermentum et sollicitudin. Id semper risus in hendrerit. Mauris augue neque gravida in fermentum. Eros donec ac odio tempor orci dapibus. Metus dictum at tempor commodo ullamcorper a lacus vestibulum. Orci phasellus egestas tellus rutrum tellus pellentesque. Ut etiam sit amet nisl purus in. Et ultrices neque ornare aenean euismod elementum. Risus commodo viverra maecenas accumsan lacus vel facilisis volutpat est. Nec feugiat in fermentum posuere urna nec tincidunt praesent semper. Enim nulla aliquet porttitor lacus luctus.\n\n\n\nFaucibus in ornare quam viverra orci sagittis eu volutpat odio. Justo nec ultrices dui sapien eget mi. Odio facilisis mauris sit amet. Sit amet commodo nulla facilisi nullam vehicula ipsum. Ut tristique et egestas quis ipsum. Mi eget mauris pharetra et ultrices neque ornare aenean euismod. Tortor id aliquet lectus proin nibh nisl. Eu lobortis elementum nibh tellus molestie nunc. Augue mauris augue neque gravida in fermentum. Quis vel eros donec ac odio tempor orci. Et ultrices neque ornare aenean euismod. Pellentesque massa placerat duis ultricies. Justo eget magna fermentum iaculis eu non diam phasellus vestibulum. In pellentesque massa placerat duis ultricies lacus sed turpis tincidunt. A diam sollicitudin tempor id eu nisl.",
					"added_by": "Praveen Provider Soni",
					"last_edited_by": null,
					"status": 0,
					"created": "2020-04-14 15:26:50",
					"modified": "2020-04-14 15:27:08",
					"order_by": 4,
					"initials_per_page": 0,
					"witness_signature": 0
				}
			}, {
				"id": 188,
				"consent_id": 8,
				"signature_image_url": "",
				"signature_thumb_image_url": "",
				"witness_signature_url": "",
				"witness_signature_thumb_image_url": "",
				"created_format_date": "0000-00-00 00:00:00",
				"consent": {
					"id": 8,
					"consent_name": "000 AAA PS Third Consent",
					"consent_small_description": null,
					"consent_large_description": "Vel facilisis volutpat est velit egestas dui id. Nunc sed blandit libero volutpat sed cras ornare arcu dui. Id cursus metus aliquam eleifend mi in. Egestas quis ipsum suspendisse ultrices gravida. Duis at consectetur lorem donec massa sapien. Velit euismod in pellentesque massa placerat. Purus viverra accumsan in nisl nisi scelerisque eu. Nunc congue nisi vitae suscipit tellus mauris. Facilisi nullam vehicula ipsum a arcu cursus. Et ultrices neque ornare aenean euismod elementum.\n\n\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vel fringilla est ullamcorper eget nulla facilisi etiam. Non consectetur a erat nam at lectus urna. Nisl pretium fusce id velit ut tortor pretium viverra suspendisse. Consectetur adipiscing elit duis tristique sollicitudin nibh sit. Ullamcorper velit sed ullamcorper morbi tincidunt ornare massa eget egestas. Mauris commodo quis imperdiet massa tincidunt nunc pulvinar sapien et. Dignissim diam quis enim lobortis scelerisque fermentum dui faucibus. Pulvinar sapien et ligula ullamcorper malesuada proin libero nunc consequat. Tristique magna sit amet purus. Eu augue ut lectus arcu bibendum at varius. Tristique magna sit amet purus gravida. Sed odio morbi quis commodo odio aenean sed adipiscing diam. Amet facilisis magna etiam tempor orci eu. Tellus in metus vulputate eu scelerisque felis imperdiet. Odio morbi quis commodo odio. Dictumst quisque sagittis purus sit amet volutpat consequat mauris nunc.\n\n\n\nVel pretium lectus quam id leo in. At ultrices mi tempus imperdiet nulla. Amet porttitor eget dolor morbi. Ligula ullamcorper malesuada proin libero nunc consequat interdum. Purus ut faucibus pulvinar elementum integer enim neque. Vel pharetra vel turpis nunc eget. Eget mauris pharetra et ultrices neque ornare aenean euismod. Neque aliquam vestibulum morbi blandit. Ut diam quam nulla porttitor massa. Pretium aenean pharetra magna ac placerat vestibulum. Suspendisse interdum consectetur libero id. Fermentum et sollicitudin ac orci phasellus egestas tellus rutrum. Eu augue ut lectus arcu bibendum. Integer eget aliquet nibh praesent tristique magna sit. Tellus cras adipiscing enim eu turpis egestas.\n\n\n\n\n\nAuctor augue mauris augue neque gravida in fermentum et sollicitudin. Id semper risus in hendrerit. Mauris augue neque gravida in fermentum. Eros donec ac odio tempor orci dapibus. Metus dictum at tempor commodo ullamcorper a lacus vestibulum. Orci phasellus egestas tellus rutrum tellus pellentesque. Ut etiam sit amet nisl purus in. Et ultrices neque ornare aenean euismod elementum. Risus commodo viverra maecenas accumsan lacus vel facilisis volutpat est. Nec feugiat in fermentum posuere urna nec tincidunt praesent semper. Enim nulla aliquet porttitor lacus luctus.\n\n\n\nFaucibus in ornare quam viverra orci sagittis eu volutpat odio. Justo nec ultrices dui sapien eget mi. Odio facilisis mauris sit amet. Sit amet commodo nulla facilisi nullam vehicula ipsum. Ut tristique et egestas quis ipsum. Mi eget mauris pharetra et ultrices neque ornare aenean euismod. Tortor id aliquet lectus proin nibh nisl. Eu lobortis elementum nibh tellus molestie nunc. Augue mauris augue neque gravida in fermentum. Quis vel eros donec ac odio tempor orci. Et ultrices neque ornare aenean euismod. Pellentesque massa placerat duis ultricies. Justo eget magna fermentum iaculis eu non diam phasellus vestibulum. In pellentesque massa placerat duis ultricies lacus sed turpis tincidunt. A diam sollicitudin tempor id eu nisl.",
					"added_by": "Praveen Provider Soni",
					"last_edited_by": null,
					"status": 0,
					"created": "2020-04-14 15:28:03",
					"modified": "2020-04-14 15:28:47",
					"order_by": 6,
					"initials_per_page": 0,
					"witness_signature": 1
				}
			}],
			"procedure_questionnaries": [{
				"id": 5,
				"consultation_title": "000 AAA PS Cosmetic 001",
				"status": 0,
				"created": "2020-03-31 09:30:00",
				"modified": "2020-03-31 09:30:00",
				"order_by": 3
			}, {
				"id": 6,
				"consultation_title": "000 AAA PS Cosmetic 002",
				"status": 0,
				"created": "2020-03-31 09:30:00",
				"modified": "2020-03-31 09:30:00",
				"order_by": 4
			}],
			"can_send_post_instruction": 0,
			"show_consents_btn": 0,
			"procedure_image_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1590051331_idw1Jfl0MvI.jpg",
			"procedure_image_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1590051331_idw1Jfl0MvI.jpg",
			"procedure_image_45_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1590051309_yG_kRzUtajU.jpg",
			"procedure_image_45_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1590051309_yG_kRzUtajU.jpg",
			"procedure_date_new": "2020-05-20",
			"pdf_image": {
				"id": 60,
				"procedure_id": 575,
				"front_pdf_image": "photo1589981889497.jpg",
				"left_pdf_image": null,
				"right_pdf_image": null,
				"left_pdf_image_45": "photo1589981889493.jpg",
				"right_pdf_image_45": "photo1589981889501.jpg",
				"back_pdf_image": null,
				"back_pdf_image_left_45": null,
				"back_pdf_image_right_45": null,
				"status": 0,
				"created": "2020-05-20 19:08:15",
				"modified": "2020-05-20 19:08:15",
				"front_pdf_image_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_photo1589981889497.jpg",
				"front_pdf_image_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/photo1589981889497.jpg",
				"left_pdf_image_thumb_url": "",
				"left_pdf_image_url": "",
				"left_pdf_image_45_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_photo1589981889493.jpg",
				"left_pdf_image_45_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/photo1589981889493.jpg",
				"right_pdf_image_thumb_url": "",
				"right_pdf_image_url": "",
				"right_pdf_image_45_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_photo1589981889501.jpg",
				"right_pdf_image_45_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/photo1589981889501.jpg",
				"back_pdf_image_left_45_thumb_url": "",
				"back_pdf_image_left_45_url": "",
				"back_pdf_image_right_45_thumb_url": "",
				"back_pdf_image_right_45_url": "",
				"back_pdf_image_thumb_url": "",
				"back_pdf_image_url": ""
			},
			"procedure_image_data": {
				"id": 207,
				"procedure_id": 575,
				"patient_image_front": "1589956439_l5WkH62SUz4.jpg",
				"patient_image_left": "1590051337_B0rjvrRZbuc.jpg",
				"patient_image_right": "1589956455_fV8rAqtH1Js.jpg",
				"patient_image_left_45": "1589956447_Bl3kW5y6XpI.jpg",
				"patient_image_right_45": "1590051315_y7B2w6y9FyY.jpg",
				"patient_image_back": null,
				"patient_image_back_left_45": null,
				"patient_image_back_right_45": null,
				"status": 0,
				"created": "-0001-11-30",
				"modified": "-0001-11-30",
				"patient_image_front_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1589956439_l5WkH62SUz4.jpg",
				"patient_image_front_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1589956439_l5WkH62SUz4.jpg",
				"patient_image_left_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1590051337_B0rjvrRZbuc.jpg",
				"patient_image_left_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1590051337_B0rjvrRZbuc.jpg",
				"patient_image_left_45_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1589956447_Bl3kW5y6XpI.jpg",
				"patient_image_left_45_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1589956447_Bl3kW5y6XpI.jpg",
				"patient_image_right_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1589956455_fV8rAqtH1Js.jpg",
				"patient_image_right_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1589956455_fV8rAqtH1Js.jpg",
				"patient_image_right_45_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1590051315_y7B2w6y9FyY.jpg",
				"patient_image_right_45_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1590051315_y7B2w6y9FyY.jpg",
				"patient_image_back_left_45_thumb_url": "",
				"patient_image_back_left_45_url": "",
				"patient_image_back_right_45_thumb_url": "",
				"patient_image_back_right_45_url": "",
				"patient_image_back_thumb_url": "",
				"patient_image_back_url": ""
			},
			"pos_invoices": null,
			"clinic": {
				"id": 1,
				"tax": 0
			},
			"user": {
				"id": 11062,
				"firstname": "Praveen Provider",
				"lastname": "Soni",
				"signature": "110621587731461.png",
				"role_name": "",
				"user_image_url": "",
				"signature_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/signatures\/110621587731461.png",
				"full_name": "Praveen Provider Soni"
			},
			"procedure_notes": [],
			"procedure_information": [],
			"answers": [{
				"id": 1783,
				"procedure_id": 575,
				"consultation_id": 5,
				"question_id": 0,
				"answer": 0,
				"comment": null,
				"status": 0,
				"created": "2020-05-21 14:26:28",
				"modified": "2020-05-21 14:26:28"
			}, {
				"id": 1784,
				"procedure_id": 575,
				"consultation_id": 6,
				"question_id": 0,
				"answer": 0,
				"comment": null,
				"status": 0,
				"created": "2020-05-21 14:26:28",
				"modified": "2020-05-21 14:26:28"
			}],
			"answer_multiples": []
		},
		{
			"id": 445,
			"user_id": 11061,
			"clinic_id": 1,
			"type": "face",
			"doctor_name": "Praveen MD Soni",
			"patient_id": 192,
			"procedure_name": "jjhh",
			"procedure_date": "2020-04-23 20:52:00",
			"procedure_image": null,
			"procedure_image_45": null,
			"consent_ids": null,
			"note": "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
			"count_flag": null,
			"status": 0,
			"added_from": "web",
			"edited_from": "web",
			"created": "2020-04-23 20:53:00",
			"modified": "2020-04-24 14:10:31",
			"md_signed": 0,
			"md_signature": null,
			"appointment_id": 0,
			"service_id": 0,
			"invoice_id": 0,
			"sent_to_md": 0,
			"md_user_id": 0,
			"provider_signature": null,
			"provider_signed": 0,
			"save_status": "final",
			"is_consult": 0,
			"is_after_photos": 0,
			"procedure_type": "health",
			"consultation_fee": 0,
			"procedure_template_id": 0,
			"is_hidden": 0,
			"md_signed_on": "0000-00-00 00:00:00",
			"provider_signed_on": "0000-00-00 00:00:00",
			"after_photos_available": 0,
			"template_used": 0,
			"chief_complaint": null,
			"answers_count": 0,
			"answer_multiples_count": 0,
			"procedure_image_thumb_url": "",
			"procedure_image_url": "",
			"procedure_image_45_thumb_url": "",
			"procedure_image_45_url": "",
			"procedure_date_new": "2020-04-24",
			"appointment": null,
			"clinic": {
				"id": 1,
				"clinic_name": "Your Demo Clinic",
				"contact_no": "+918699153575",
				"city": "MOHALI",
				"address": "Sector17Bus Stand Road 17H",
				"clinic_city": "Chandigarh",
				"clinic_state": "CH",
				"clinic_zipcode": "160022"
			},
			"consents": [],
			"procedure_prescription": [{
				"id": 160,
				"procedure_id": 445,
				"medicine_name": "d3",
				"dosage": "1",
				"frequency": "1",
				"duration": "",
				"procedure_prescription_information_id": 50,
				"form": "Tuesday",
				"strength": "23",
				"quantity": 2,
				"refills": 7,
				"procedure_prescription_information": {
					"id": 50,
					"procedure_id": 445,
					"user_id": 11061,
					"status": 0,
					"prescription_note": null,
					"pharmacy_id": 13,
					"date_needed": "2020-05-26",
					"ship_to": "patient",
					"created": "2020-05-20 10:11:26",
					"modified": "2020-05-20 15:11:26",
					"pdf_file_name": "prescription052020031126.pdf",
					"will_there_be_access_to": "",
					"is_patient_new_to_therapy": 0,
					"is_patient_restarting_therapy": 0,
					"is_patient_currently_on_therapy": 0,
					"primary_diagnosis_code": "",
					"date_of_diagnosis": "2020-05-20",
					"start_date": "2020-05-20",
					"other_diagnosis_conditions": "",
					"current_weight": null,
					"weight_type": "kg",
					"date_of_last_weight": null,
					"current_height": null,
					"height_type": "cm",
					"last_date_of_height": "2020-05-20",
					"other_therapies_tried_failed": "",
					"prescriber_fax": null,
					"best_time_to_call": "",
					"preferred_method_of_contact": "fax",
					"substitution_permitted": "no",
					"allergies": "",
					"office_contact": "",
					"prescriber_address": "Sector17Bus Stand Road 17H",
					"prescriber_city": "Chandigarh",
					"prescriber_state": "CH",
					"prescriber_zipcode": "",
					"prescriber_phone": "+918699153575",
					"signature": "photo1589983883856.jpg",
					"prescriber_email": "praveen.md.kiran@yopmail.com",
					"signature_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/signatures\/photo1589983883856.jpg",
					"pharmacy": {
						"id": 13,
						"name": "Alkem Laboratories",
						"user_id": 11189,
						"status": 0,
						"fax": "+12129324000",
						"phone": "+12129324000",
						"created": "2020-05-07 02:07:26",
						"modified": "2020-05-08 08:01:58",
						"email": "Mukesh_Alkem@Yopmail.Com",
						"how_will_send_prescription": "email",
						"address": "Baddi Address",
						"state": "India",
						"country": "In",
						"city": "Baddi",
						"zipcode": "173205"
					}
				}
			}, {
				"id": 159,
				"procedure_id": 445,
				"medicine_name": "b12",
				"dosage": "1",
				"frequency": "1",
				"duration": "",
				"procedure_prescription_information_id": 50,
				"form": "Monday",
				"strength": "12",
				"quantity": 1,
				"refills": 1,
				"procedure_prescription_information": {
					"id": 50,
					"procedure_id": 445,
					"user_id": 11061,
					"status": 0,
					"prescription_note": null,
					"pharmacy_id": 13,
					"date_needed": "2020-05-26",
					"ship_to": "patient",
					"created": "2020-05-20 10:11:26",
					"modified": "2020-05-20 15:11:26",
					"pdf_file_name": "prescription052020031126.pdf",
					"will_there_be_access_to": "",
					"is_patient_new_to_therapy": 0,
					"is_patient_restarting_therapy": 0,
					"is_patient_currently_on_therapy": 0,
					"primary_diagnosis_code": "",
					"date_of_diagnosis": "2020-05-20",
					"start_date": "2020-05-20",
					"other_diagnosis_conditions": "",
					"current_weight": null,
					"weight_type": "kg",
					"date_of_last_weight": null,
					"current_height": null,
					"height_type": "cm",
					"last_date_of_height": "2020-05-20",
					"other_therapies_tried_failed": "",
					"prescriber_fax": null,
					"best_time_to_call": "",
					"preferred_method_of_contact": "fax",
					"substitution_permitted": "no",
					"allergies": "",
					"office_contact": "",
					"prescriber_address": "Sector17Bus Stand Road 17H",
					"prescriber_city": "Chandigarh",
					"prescriber_state": "CH",
					"prescriber_zipcode": "",
					"prescriber_phone": "+918699153575",
					"signature": "photo1589983883856.jpg",
					"prescriber_email": "praveen.md.kiran@yopmail.com",
					"signature_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/signatures\/photo1589983883856.jpg",
					"pharmacy": {
						"id": 13,
						"name": "Alkem Laboratories",
						"user_id": 11189,
						"status": 0,
						"fax": "+12129324000",
						"phone": "+12129324000",
						"created": "2020-05-07 02:07:26",
						"modified": "2020-05-08 08:01:58",
						"email": "Mukesh_Alkem@Yopmail.Com",
						"how_will_send_prescription": "email",
						"address": "Baddi Address",
						"state": "India",
						"country": "In",
						"city": "Baddi",
						"zipcode": "173205"
					}
				}
			}],
			"procedure_notes": [{
				"id": 90,
				"procedure_id": 445,
				"user_id": 11062,
				"patient_id": 192,
				"title": "",
				"notes": "First",
				"added_by": null,
				"created": "2020-05-20 10:12:28",
				"modified": "2020-05-20 10:12:28",
				"hashtags": null
			}],
			"pos_invoices": null,
			"user": {
				"id": 11061,
				"clinic_id": 1,
				"user_role_id": 4,
				"is_provider": true,
				"account_id": 1937,
				"supplementary_title": null,
				"firstname": "Praveen MD",
				"lastname": "Soni",
				"email_id": "praveen.md.kiran@yopmail.com",
				"pass_code": 9102,
				"signature": "",
				"website": null,
				"contact_number_1": null,
				"contact_number_2": null,
				"contact_number_3": null,
				"contact_number_4": null,
				"address_line_1": null,
				"address_line_2": null,
				"address_line_3": null,
				"address_line_4": null,
				"pincode": null,
				"city": "Mohali",
				"state": "Punjab",
				"country": "India",
				"user_image": null,
				"status": "Active",
				"session_id": "",
				"web_session_id": "a184cfaaeee3108316a25cce346a4159",
				"last_login_ip": "2405:201:5200:676d:9d10:4a60:78f1:94c6",
				"last_login_date": "2020-05-20 20:02:46",
				"created": "2020-01-01 12:35:51",
				"modified": "2020-05-20",
				"password_flag": 0,
				"monthly_procedure_goal": 100,
				"weekly_procedure_goal": 20,
				"monthly_sales_goal": 200,
				"weekly_sales_goal": 40,
				"is_md_consent_required": true,
				"timezone": "Asia\/Kolkata",
				"appointment_color": "#E15D44",
				"vacation_mode": 0,
				"vacation_startdate": "0000-00-00",
				"vacation_enddate": "0000-00-00",
				"last_activity": "2020-02-12 17:07:03",
				"web_last_activity": "2020-05-20 20:27:59",
				"bio_name": "PS MD",
				"bio_title": "PS MD",
				"bio_description": "PS MD",
				"gender": null,
				"dob": "0000-00-00",
				"is_available_online": true,
				"md_user_id": 11061,
				"show_signature_popup": true,
				"is_dashboard_enabled": true,
				"display_order": 2,
				"is_demo": 0,
				"commission_percentage": 10,
				"receive_checkin_sms": 0,
				"app_version": "8.10.2",
				"email_id_2": null,
				"email_id_3": null,
				"cash_drawer_notification": 1,
				"super_account_id": 0,
				"super_user": 0,
				"degree_designation": "NP",
				"hourly_rate": 5,
				"procedure_steps": null,
				"state_license": "",
				"dea": "",
				"npi": "",
				"medicaid_upin": "",
				"role_name": "md",
				"user_image_url": "",
				"signature_url": "",
				"full_name": "Praveen MD Soni"
			},
			"prescription_pdf_url": "https:\/\/devapi.aestheticrecord.com\/excel\/prescription052020031126.pdf",
			"pharmacy_fax_enabled": 1,
			"pharmacy_email_enabled": 1,
			"show_questionnaires_btn": -1,
			"show_consents_btn": -1
		},
		{
			"id": 572,
			"user_id": 11062,
			"clinic_id": 1,
			"type": "coolsculpting",
			"doctor_name": "Praveen Provider Soni",
			"patient_id": 192,
			"procedure_name": "20200521 002",
			"procedure_date": "2020-05-20 12:00:00",
			"procedure_image": null,
			"procedure_image_45": null,
			"consent_ids": "183,184",
			"note": null,
			"count_flag": null,
			"status": 0,
			"added_from": "",
			"edited_from": "",
			"created": "2020-05-20 12:01:40",
			"modified": "2020-05-21 20:55:56",
			"md_signed": 0,
			"md_signature": null,
			"appointment_id": 0,
			"service_id": 0,
			"invoice_id": 0,
			"sent_to_md": 0,
			"md_user_id": 0,
			"provider_signature": null,
			"provider_signed": 0,
			"save_status": "final",
			"is_consult": 0,
			"is_after_photos": 0,
			"procedure_type": "cosmetic",
			"consultation_fee": 0,
			"procedure_template_id": 0,
			"is_hidden": 0,
			"md_signed_on": "0000-00-00 00:00:00",
			"provider_signed_on": "0000-00-00 00:00:00",
			"after_photos_available": 1,
			"template_used": 1,
			"chief_complaint": null,
			"answers_count": 0,
			"answer_multiples_count": 0,
			"total_price": 0,
			"product_data": [],
			"injection_array": [],
			"total_tax": 0,
			"total_image_count": 5,
			"combined_image": null,
			"combined_image_45": null,
			"survey_appointment_id": null,
			"ba_videos_available": 0,
			"consent_data": [{
				"id": 183,
				"consent_id": 7,
				"signature_image_url": "",
				"signature_thumb_image_url": "",
				"witness_signature_url": "",
				"witness_signature_thumb_image_url": "",
				"created_format_date": "0000-00-00 00:00:00",
				"consent": {
					"id": 7,
					"consent_name": "000 AAA PS Second Consent",
					"consent_small_description": null,
					"consent_large_description": "Second \n\nAuctor augue mauris augue neque gravida in fermentum et sollicitudin. Id semper risus in hendrerit. Mauris augue neque gravida in fermentum. Eros donec ac odio tempor orci dapibus. Metus dictum at tempor commodo ullamcorper a lacus vestibulum. Orci phasellus egestas tellus rutrum tellus pellentesque. Ut etiam sit amet nisl purus in. Et ultrices neque ornare aenean euismod elementum. Risus commodo viverra maecenas accumsan lacus vel facilisis volutpat est. Nec feugiat in fermentum posuere urna nec tincidunt praesent semper. Enim nulla aliquet porttitor lacus luctus.\n\n\n\nFaucibus in ornare quam viverra orci sagittis eu volutpat odio. Justo nec ultrices dui sapien eget mi. Odio facilisis mauris sit amet. Sit amet commodo nulla facilisi nullam vehicula ipsum. Ut tristique et egestas quis ipsum. Mi eget mauris pharetra et ultrices neque ornare aenean euismod. Tortor id aliquet lectus proin nibh nisl. Eu lobortis elementum nibh tellus molestie nunc. Augue mauris augue neque gravida in fermentum. Quis vel eros donec ac odio tempor orci. Et ultrices neque ornare aenean euismod. Pellentesque massa placerat duis ultricies. Justo eget magna fermentum iaculis eu non diam phasellus vestibulum. In pellentesque massa placerat duis ultricies lacus sed turpis tincidunt. A diam sollicitudin tempor id eu nisl.",
					"added_by": "Praveen Provider Soni",
					"last_edited_by": null,
					"status": 0,
					"created": "2020-04-14 15:27:25",
					"modified": "2020-04-14 15:27:25",
					"order_by": 5,
					"initials_per_page": 1,
					"witness_signature": 0
				}
			}, {
				"id": 184,
				"consent_id": 9,
				"signature_image_url": "",
				"signature_thumb_image_url": "",
				"witness_signature_url": "",
				"witness_signature_thumb_image_url": "",
				"created_format_date": "0000-00-00 00:00:00",
				"consent": {
					"id": 9,
					"consent_name": "000 AAA PS Fourth Consent",
					"consent_small_description": null,
					"consent_large_description": "Vel facilisis volutpat est velit egestas dui id. Nunc sed blandit libero volutpat sed cras ornare arcu dui. Id cursus metus aliquam eleifend mi in. Egestas quis ipsum suspendisse ultrices gravida. Duis at consectetur lorem donec massa sapien. Velit euismod in pellentesque massa placerat. Purus viverra accumsan in nisl nisi scelerisque eu. Nunc congue nisi vitae suscipit tellus mauris. Facilisi nullam vehicula ipsum a arcu cursus. Et ultrices neque ornare aenean euismod elementum.\n\n\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vel fringilla est ullamcorper eget nulla facilisi etiam. Non consectetur a erat nam at lectus urna. Nisl pretium fusce id velit ut tortor pretium viverra suspendisse. Consectetur adipiscing elit duis tristique sollicitudin nibh sit. Ullamcorper velit sed ullamcorper morbi tincidunt ornare massa eget egestas. Mauris commodo quis imperdiet massa tincidunt nunc pulvinar sapien et. Dignissim diam quis enim lobortis scelerisque fermentum dui faucibus. Pulvinar sapien et ligula ullamcorper malesuada proin libero nunc consequat. Tristique magna sit amet purus. Eu augue ut lectus arcu bibendum at varius. Tristique magna sit amet purus gravida. Sed odio morbi quis commodo odio aenean sed adipiscing diam. Amet facilisis magna etiam tempor orci eu. Tellus in metus vulputate eu scelerisque felis imperdiet. Odio morbi quis commodo odio. Dictumst quisque sagittis purus sit amet volutpat consequat mauris nunc.\n\n\n\nVel pretium lectus quam id leo in. At ultrices mi tempus imperdiet nulla. Amet porttitor eget dolor morbi. Ligula ullamcorper malesuada proin libero nunc consequat interdum. Purus ut faucibus pulvinar elementum integer enim neque. Vel pharetra vel turpis nunc eget. Eget mauris pharetra et ultrices neque ornare aenean euismod. Neque aliquam vestibulum morbi blandit. Ut diam quam nulla porttitor massa. Pretium aenean pharetra magna ac placerat vestibulum. Suspendisse interdum consectetur libero id. Fermentum et sollicitudin ac orci phasellus egestas tellus rutrum. Eu augue ut lectus arcu bibendum. Integer eget aliquet nibh praesent tristique magna sit. Tellus cras adipiscing enim eu turpis egestas.\n\n\n\n\n\nAuctor augue mauris augue neque gravida in fermentum et sollicitudin. Id semper risus in hendrerit. Mauris augue neque gravida in fermentum. Eros donec ac odio tempor orci dapibus. Metus dictum at tempor commodo ullamcorper a lacus vestibulum. Orci phasellus egestas tellus rutrum tellus pellentesque. Ut etiam sit amet nisl purus in. Et ultrices neque ornare aenean euismod elementum. Risus commodo viverra maecenas accumsan lacus vel facilisis volutpat est. Nec feugiat in fermentum posuere urna nec tincidunt praesent semper. Enim nulla aliquet porttitor lacus luctus.\n\n\n\nFaucibus in ornare quam viverra orci sagittis eu volutpat odio. Justo nec ultrices dui sapien eget mi. Odio facilisis mauris sit amet. Sit amet commodo nulla facilisi nullam vehicula ipsum. Ut tristique et egestas quis ipsum. Mi eget mauris pharetra et ultrices neque ornare aenean euismod. Tortor id aliquet lectus proin nibh nisl. Eu lobortis elementum nibh tellus molestie nunc. Augue mauris augue neque gravida in fermentum. Quis vel eros donec ac odio tempor orci. Et ultrices neque ornare aenean euismod. Pellentesque massa placerat duis ultricies. Justo eget magna fermentum iaculis eu non diam phasellus vestibulum. In pellentesque massa placerat duis ultricies lacus sed turpis tincidunt. A diam sollicitudin tempor id eu nisl.",
					"added_by": "Praveen Provider Soni",
					"last_edited_by": null,
					"status": 0,
					"created": "2020-04-14 15:28:39",
					"modified": "2020-04-14 15:28:39",
					"order_by": 7,
					"initials_per_page": 1,
					"witness_signature": 1
				}
			}],
			"procedure_questionnaries": [{
				"id": 5,
				"consultation_title": "000 AAA PS Cosmetic 001",
				"status": 0,
				"created": "2020-03-31 09:30:00",
				"modified": "2020-03-31 09:30:00",
				"order_by": 3
			}, {
				"id": 6,
				"consultation_title": "000 AAA PS Cosmetic 002",
				"status": 0,
				"created": "2020-03-31 09:30:00",
				"modified": "2020-03-31 09:30:00",
				"order_by": 4
			}],
			"can_send_post_instruction": 0,
			"show_consents_btn": 0,
			"procedure_image_thumb_url": "",
			"procedure_image_url": "",
			"procedure_image_45_thumb_url": "",
			"procedure_image_45_url": "",
			"procedure_date_new": "2020-05-20",
			"pdf_image": null,
			"procedure_image_data": {
				"id": 211,
				"procedure_id": 572,
				"patient_image_front": "1590074661_I7I4cir4dTc.jpg",
				"patient_image_left": "1589956277_bLbRF0XWHJs.jpg",
				"patient_image_right": "1589956273_idw1Jfl0MvI.jpg",
				"patient_image_left_45": "1589956265_osz-FCr7fyY.jpg",
				"patient_image_right_45": "1589956268_a6PXS-INGWI.jpg",
				"patient_image_back": "1590074649_QzgYiPTd-qU.jpg",
				"patient_image_back_left_45": "1590074669_Fr6yqpRIeqY.jpg",
				"patient_image_back_right_45": "1590074674_fHxXeFqtdaI.jpg",
				"status": 0,
				"created": "-0001-11-30",
				"modified": "-0001-11-30",
				"patient_image_front_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1590074661_I7I4cir4dTc.jpg",
				"patient_image_front_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1590074661_I7I4cir4dTc.jpg",
				"patient_image_left_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1589956277_bLbRF0XWHJs.jpg",
				"patient_image_left_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1589956277_bLbRF0XWHJs.jpg",
				"patient_image_left_45_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1589956265_osz-FCr7fyY.jpg",
				"patient_image_left_45_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1589956265_osz-FCr7fyY.jpg",
				"patient_image_right_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1589956273_idw1Jfl0MvI.jpg",
				"patient_image_right_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1589956273_idw1Jfl0MvI.jpg",
				"patient_image_right_45_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1589956268_a6PXS-INGWI.jpg",
				"patient_image_right_45_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1589956268_a6PXS-INGWI.jpg",
				"patient_image_back_left_45_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1590074669_Fr6yqpRIeqY.jpg",
				"patient_image_back_left_45_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1590074669_Fr6yqpRIeqY.jpg",
				"patient_image_back_right_45_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1590074674_fHxXeFqtdaI.jpg",
				"patient_image_back_right_45_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1590074674_fHxXeFqtdaI.jpg",
				"patient_image_back_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1590074649_QzgYiPTd-qU.jpg",
				"patient_image_back_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1590074649_QzgYiPTd-qU.jpg"
			},
			"pos_invoices": null,
			"clinic": {
				"id": 1,
				"tax": 0
			},
			"user": {
				"id": 11062,
				"firstname": "Praveen Provider",
				"lastname": "Soni",
				"signature": "110621587731461.png",
				"role_name": "",
				"user_image_url": "",
				"signature_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/signatures\/110621587731461.png",
				"full_name": "Praveen Provider Soni"
			},
			"injections": [],
			"procedure_notes": [],
			"procedure_information": [],
			"answers": [{
				"id": 1778,
				"procedure_id": 572,
				"consultation_id": 5,
				"question_id": 0,
				"answer": 0,
				"comment": null,
				"status": 0,
				"created": "2020-05-20 12:01:40",
				"modified": "2020-05-20 12:01:40"
			}, {
				"id": 1779,
				"procedure_id": 572,
				"consultation_id": 6,
				"question_id": 0,
				"answer": 0,
				"comment": null,
				"status": 0,
				"created": "2020-05-20 12:01:40",
				"modified": "2020-05-20 12:01:40"
			}],
			"answer_multiples": []
		},		
		{
			"id": 573,
			"user_id": 11062,
			"clinic_id": 1,
			"type": "chest",
			"doctor_name": "Praveen Provider Soni",
			"patient_id": 192,
			"procedure_name": "20200521 003",
			"procedure_date": "2020-05-20 12:01:00",
			"procedure_image": null,
			"procedure_image_45": null,
			"consent_ids": null,
			"note": null,
			"count_flag": null,
			"status": 0,
			"added_from": "",
			"edited_from": "",
			"created": "2020-05-20 12:02:33",
			"modified": "2020-05-20 12:02:33",
			"md_signed": 0,
			"md_signature": null,
			"appointment_id": 0,
			"service_id": 0,
			"invoice_id": 0,
			"sent_to_md": 0,
			"md_user_id": 0,
			"provider_signature": null,
			"provider_signed": 0,
			"save_status": "final",
			"is_consult": 0,
			"is_after_photos": 0,
			"procedure_type": "cosmetic",
			"consultation_fee": 0,
			"procedure_template_id": 0,
			"is_hidden": 0,
			"md_signed_on": "0000-00-00 00:00:00",
			"provider_signed_on": "0000-00-00 00:00:00",
			"after_photos_available": 0,
			"template_used": 1,
			"chief_complaint": null,
			"answers_count": 0,
			"answer_multiples_count": 0,
			"total_price": 0,
			"product_data": [],
			"injection_array": [],
			"total_tax": 0,
			"total_image_count": 1,
			"combined_image": null,
			"combined_image_45": null,
			"survey_appointment_id": null,
			"ba_videos_available": 0,
			"consent_data": [],
			"procedure_questionnaries": [],
			"can_send_post_instruction": 0,
			"show_consents_btn": -1,
			"procedure_image_thumb_url": "",
			"procedure_image_url": "",
			"procedure_image_45_thumb_url": "",
			"procedure_image_45_url": "",
			"procedure_date_new": "2020-05-20",
			"pdf_image": null,
			"procedure_image_data": {
				"id": 199,
				"procedure_id": 573,
				"patient_image_front": "1589956333_gnN_VrxJ3MA.jpg",
				"patient_image_left": null,
				"patient_image_right": "1589956350_B0rjvrRZbuc.jpg",
				"patient_image_left_45": "1589956345_bLbRF0XWHJs.jpg",
				"patient_image_right_45": null,
				"patient_image_back": null,
				"patient_image_back_left_45": null,
				"patient_image_back_right_45": null,
				"status": 0,
				"created": "-0001-11-30",
				"modified": "-0001-11-30",
				"patient_image_front_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1589956333_gnN_VrxJ3MA.jpg",
				"patient_image_front_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1589956333_gnN_VrxJ3MA.jpg",
				"patient_image_left_thumb_url": "",
				"patient_image_left_url": "",
				"patient_image_left_45_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1589956345_bLbRF0XWHJs.jpg",
				"patient_image_left_45_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1589956345_bLbRF0XWHJs.jpg",
				"patient_image_right_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1589956350_B0rjvrRZbuc.jpg",
				"patient_image_right_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1589956350_B0rjvrRZbuc.jpg",
				"patient_image_right_45_thumb_url": "",
				"patient_image_right_45_url": "",
				"patient_image_back_left_45_thumb_url": "",
				"patient_image_back_left_45_url": "",
				"patient_image_back_right_45_thumb_url": "",
				"patient_image_back_right_45_url": "",
				"patient_image_back_thumb_url": "",
				"patient_image_back_url": ""
			},
			"pos_invoices": null,
			"clinic": {
				"id": 1,
				"tax": 0
			},
			"user": {
				"id": 11062,
				"firstname": "Praveen Provider",
				"lastname": "Soni",
				"signature": "110621587731461.png",
				"role_name": "",
				"user_image_url": "",
				"signature_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/signatures\/110621587731461.png",
				"full_name": "Praveen Provider Soni"
			},
			"injections": [],
			"procedure_notes": [],
			"procedure_information": [],
			"answers": [],
			"answer_multiples": []
		},
		{
			"id": 423,
			"user_id": 11061,
			"clinic_id": 1,
			"type": "face",
			"doctor_name": "Praveen MD Soni",
			"patient_id": 192,
			"procedure_name": "ps 00023",
			"procedure_date": "2020-04-21 18:37:00",
			"procedure_image": null,
			"procedure_image_45": null,
			"consent_ids": null,
			"note": "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
			"count_flag": null,
			"status": 0,
			"added_from": "web",
			"edited_from": "web",
			"created": "2020-04-21 18:37:38",
			"modified": "2020-04-22 16:08:20",
			"md_signed": 0,
			"md_signature": null,
			"appointment_id": 0,
			"service_id": 0,
			"invoice_id": 0,
			"sent_to_md": 0,
			"md_user_id": 0,
			"provider_signature": null,
			"provider_signed": 0,
			"save_status": "final",
			"is_consult": 0,
			"is_after_photos": 0,
			"procedure_type": "health",
			"consultation_fee": 0,
			"procedure_template_id": 30,
			"is_hidden": 0,
			"md_signed_on": "0000-00-00 00:00:00",
			"provider_signed_on": "0000-00-00 00:00:00",
			"after_photos_available": 0,
			"template_used": 0,
			"chief_complaint": null,
			"answers_count": 0,
			"answer_multiples_count": 0,
			"procedure_image_thumb_url": "",
			"procedure_image_url": "",
			"procedure_image_45_thumb_url": "",
			"procedure_image_45_url": "",
			"procedure_date_new": "2020-04-22",
			"appointment": null,
			"clinic": {
				"id": 1,
				"clinic_name": "Your Demo Clinic",
				"contact_no": "+918699153575",
				"city": "MOHALI",
				"address": "Sector17Bus Stand Road 17H",
				"clinic_city": "Chandigarh",
				"clinic_state": "CH",
				"clinic_zipcode": "160022"
			},
			"consents": [],
			"procedure_prescription": [],
			"procedure_notes": [],
			"pos_invoices": null,
			"user": {
				"id": 11061,
				"clinic_id": 1,
				"user_role_id": 4,
				"is_provider": true,
				"account_id": 1937,
				"supplementary_title": null,
				"firstname": "Praveen MD",
				"lastname": "Soni",
				"email_id": "praveen.md.kiran@yopmail.com",
				"pass_code": 9102,
				"signature": "",
				"website": null,
				"contact_number_1": null,
				"contact_number_2": null,
				"contact_number_3": null,
				"contact_number_4": null,
				"address_line_1": null,
				"address_line_2": null,
				"address_line_3": null,
				"address_line_4": null,
				"pincode": null,
				"city": "Mohali",
				"state": "Punjab",
				"country": "India",
				"user_image": null,
				"status": "Active",
				"session_id": "",
				"web_session_id": "9eec033f6000826b016403da5c7f0d82",
				"last_login_ip": "2405:201:5200:676d:6c62:b16c:e09b:2f80",
				"last_login_date": "2020-05-20 11:58:10",
				"created": "2020-01-01 12:35:51",
				"modified": "2020-05-20",
				"password_flag": 0,
				"monthly_procedure_goal": 100,
				"weekly_procedure_goal": 20,
				"monthly_sales_goal": 200,
				"weekly_sales_goal": 40,
				"is_md_consent_required": true,
				"timezone": "Asia\/Kolkata",
				"appointment_color": "#E15D44",
				"vacation_mode": 0,
				"vacation_startdate": "0000-00-00",
				"vacation_enddate": "0000-00-00",
				"last_activity": "2020-02-12 17:07:03",
				"web_last_activity": "2020-05-20 12:11:18",
				"bio_name": "PS MD",
				"bio_title": "PS MD",
				"bio_description": "PS MD",
				"gender": null,
				"dob": "0000-00-00",
				"is_available_online": true,
				"md_user_id": 11061,
				"show_signature_popup": true,
				"is_dashboard_enabled": true,
				"display_order": 2,
				"is_demo": 0,
				"commission_percentage": 10,
				"receive_checkin_sms": 0,
				"app_version": "8.10.2",
				"email_id_2": null,
				"email_id_3": null,
				"cash_drawer_notification": 1,
				"super_account_id": 0,
				"super_user": 0,
				"degree_designation": "NP",
				"hourly_rate": 5,
				"procedure_steps": null,
				"state_license": null,
				"dea": null,
				"npi": null,
				"medicaid_upin": null,
				"role_name": "md",
				"user_image_url": "",
				"signature_url": "",
				"full_name": "Praveen MD Soni"
			},
			"prescription_pdf_url": null,
			"pharmacy_fax_enabled": 0,
			"pharmacy_email_enabled": 0,
			"show_questionnaires_btn": 1,
			"show_consents_btn": -1
		},
		{
			"id": 422,
			"user_id": 11062,
			"clinic_id": 1,
			"type": "face",
			"doctor_name": "Praveen Provider Soni",
			"patient_id": 192,
			"procedure_name": "File upload type questionnaire",
			"procedure_date": "2020-04-21 18:24:00",
			"procedure_image": null,
			"procedure_image_45": null,
			"consent_ids": null,
			"note": "We did *** units of ***\r\n\r\n3 Recommendations are:\r\nTemples - 4 Sculptra in 3 months\r\n3 Microneedling spaced 6 weeks\r\nRepeat Botox at 4 months",
			"count_flag": null,
			"status": 0,
			"added_from": "web",
			"edited_from": "",
			"created": "2020-04-21 18:25:12",
			"modified": "2020-04-21 18:25:27",
			"md_signed": 0,
			"md_signature": null,
			"appointment_id": 0,
			"service_id": 0,
			"invoice_id": 0,
			"sent_to_md": 0,
			"md_user_id": 0,
			"provider_signature": null,
			"provider_signed": 0,
			"save_status": "final",
			"is_consult": 0,
			"is_after_photos": 0,
			"procedure_type": "health",
			"consultation_fee": 0,
			"procedure_template_id": 30,
			"is_hidden": 0,
			"md_signed_on": "0000-00-00 00:00:00",
			"provider_signed_on": "0000-00-00 00:00:00",
			"after_photos_available": 0,
			"template_used": 0,
			"chief_complaint": null,
			"answers_count": 0,
			"answer_multiples_count": 0,
			"procedure_image_thumb_url": "",
			"procedure_image_url": "",
			"procedure_image_45_thumb_url": "",
			"procedure_image_45_url": "",
			"procedure_date_new": "2020-04-22",
			"appointment": null,
			"clinic": {
				"id": 1,
				"clinic_name": "Your Demo Clinic",
				"contact_no": "+918699153575",
				"city": "MOHALI",
				"address": "Sector17Bus Stand Road 17H",
				"clinic_city": "Chandigarh",
				"clinic_state": "CH",
				"clinic_zipcode": "160022"
			},
			"consents": [],
			"procedure_prescription": [],
			"procedure_notes": [],
			"pos_invoices": null,
			"user": {
				"id": 11062,
				"clinic_id": 1,
				"user_role_id": 2,
				"is_provider": false,
				"account_id": 1937,
				"supplementary_title": null,
				"firstname": "Praveen Provider",
				"lastname": "Soni",
				"email_id": "praveen.provider.kiran@yopmail.com",
				"pass_code": 8135,
				"signature": "110621587731461.png",
				"website": null,
				"contact_number_1": null,
				"contact_number_2": null,
				"contact_number_3": null,
				"contact_number_4": null,
				"address_line_1": null,
				"address_line_2": null,
				"address_line_3": null,
				"address_line_4": null,
				"pincode": null,
				"city": "Mohali",
				"state": "Punjab",
				"country": "India",
				"user_image": null,
				"status": "Active",
				"session_id": "",
				"web_session_id": "4da9588aabd6b0509f3442c5d22b49b1",
				"last_login_ip": "49.36.154.247",
				"last_login_date": "2020-05-18 20:37:16",
				"created": "2020-01-01 12:39:09",
				"modified": "2020-05-19",
				"password_flag": 0,
				"monthly_procedure_goal": 120,
				"weekly_procedure_goal": 30,
				"monthly_sales_goal": 240,
				"weekly_sales_goal": 60,
				"is_md_consent_required": true,
				"timezone": "Asia\/Kolkata",
				"appointment_color": "#FF0000",
				"vacation_mode": 0,
				"vacation_startdate": "0000-00-00",
				"vacation_enddate": "0000-00-00",
				"last_activity": "2020-02-13 17:43:20",
				"web_last_activity": "2020-05-19 19:25:55",
				"bio_name": "PS Provider",
				"bio_title": "PS Provider",
				"bio_description": "PS Provider",
				"gender": null,
				"dob": "0000-00-00",
				"is_available_online": true,
				"md_user_id": 11189,
				"show_signature_popup": true,
				"is_dashboard_enabled": true,
				"display_order": 3,
				"is_demo": 0,
				"commission_percentage": 5,
				"receive_checkin_sms": 0,
				"app_version": "8.10.3",
				"email_id_2": null,
				"email_id_3": null,
				"cash_drawer_notification": 1,
				"super_account_id": 0,
				"super_user": 0,
				"degree_designation": "RN",
				"hourly_rate": 10,
				"procedure_steps": null,
				"state_license": "231232",
				"dea": "231232",
				"npi": "31232",
				"medicaid_upin": "32323",
				"role_name": "provider",
				"user_image_url": "",
				"signature_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/signatures\/110621587731461.png",
				"full_name": "Praveen Provider Soni"
			},
			"prescription_pdf_url": null,
			"pharmacy_fax_enabled": 0,
			"pharmacy_email_enabled": 0,
			"show_questionnaires_btn": 1,
			"show_consents_btn": -1
		},
		{
			"id": 421,
			"user_id": 11061,
			"clinic_id": 1,
			"type": "face",
			"doctor_name": "Praveen MD Soni",
			"patient_id": 192,
			"procedure_name": "new procedure",
			"procedure_date": "2020-04-21 17:16:00",
			"procedure_image": null,
			"procedure_image_45": null,
			"consent_ids": null,
			"note": "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
			"count_flag": null,
			"status": 0,
			"added_from": "web",
			"edited_from": "web",
			"created": "2020-04-21 17:17:07",
			"modified": "2020-04-21 17:51:39",
			"md_signed": 0,
			"md_signature": null,
			"appointment_id": 0,
			"service_id": 0,
			"invoice_id": 0,
			"sent_to_md": 0,
			"md_user_id": 0,
			"provider_signature": null,
			"provider_signed": 0,
			"save_status": "final",
			"is_consult": 0,
			"is_after_photos": 0,
			"procedure_type": "health",
			"consultation_fee": 0,
			"procedure_template_id": 0,
			"is_hidden": 0,
			"md_signed_on": "0000-00-00 00:00:00",
			"provider_signed_on": "0000-00-00 00:00:00",
			"after_photos_available": 0,
			"template_used": 0,
			"chief_complaint": null,
			"answers_count": 0,
			"answer_multiples_count": 0,
			"procedure_image_thumb_url": "",
			"procedure_image_url": "",
			"procedure_image_45_thumb_url": "",
			"procedure_image_45_url": "",
			"procedure_date_new": "2020-04-22",
			"appointment": null,
			"clinic": {
				"id": 1,
				"clinic_name": "Your Demo Clinic",
				"contact_no": "+918699153575",
				"city": "MOHALI",
				"address": "Sector17Bus Stand Road 17H",
				"clinic_city": "Chandigarh",
				"clinic_state": "CH",
				"clinic_zipcode": "160022"
			},
			"consents": [],
			"procedure_prescription": [],
			"procedure_notes": [],
			"pos_invoices": null,
			"user": {
				"id": 11061,
				"clinic_id": 1,
				"user_role_id": 4,
				"is_provider": true,
				"account_id": 1937,
				"supplementary_title": null,
				"firstname": "Praveen MD",
				"lastname": "Soni",
				"email_id": "praveen.md.kiran@yopmail.com",
				"pass_code": 9102,
				"signature": "",
				"website": null,
				"contact_number_1": null,
				"contact_number_2": null,
				"contact_number_3": null,
				"contact_number_4": null,
				"address_line_1": null,
				"address_line_2": null,
				"address_line_3": null,
				"address_line_4": null,
				"pincode": null,
				"city": "Mohali",
				"state": "Punjab",
				"country": "India",
				"user_image": null,
				"status": "Active",
				"session_id": "",
				"web_session_id": "9eec033f6000826b016403da5c7f0d82",
				"last_login_ip": "2405:201:5200:676d:6c62:b16c:e09b:2f80",
				"last_login_date": "2020-05-20 11:58:10",
				"created": "2020-01-01 12:35:51",
				"modified": "2020-05-20",
				"password_flag": 0,
				"monthly_procedure_goal": 100,
				"weekly_procedure_goal": 20,
				"monthly_sales_goal": 200,
				"weekly_sales_goal": 40,
				"is_md_consent_required": true,
				"timezone": "Asia\/Kolkata",
				"appointment_color": "#E15D44",
				"vacation_mode": 0,
				"vacation_startdate": "0000-00-00",
				"vacation_enddate": "0000-00-00",
				"last_activity": "2020-02-12 17:07:03",
				"web_last_activity": "2020-05-20 12:11:18",
				"bio_name": "PS MD",
				"bio_title": "PS MD",
				"bio_description": "PS MD",
				"gender": null,
				"dob": "0000-00-00",
				"is_available_online": true,
				"md_user_id": 11061,
				"show_signature_popup": true,
				"is_dashboard_enabled": true,
				"display_order": 2,
				"is_demo": 0,
				"commission_percentage": 10,
				"receive_checkin_sms": 0,
				"app_version": "8.10.2",
				"email_id_2": null,
				"email_id_3": null,
				"cash_drawer_notification": 1,
				"super_account_id": 0,
				"super_user": 0,
				"degree_designation": "NP",
				"hourly_rate": 5,
				"procedure_steps": null,
				"state_license": null,
				"dea": null,
				"npi": null,
				"medicaid_upin": null,
				"role_name": "md",
				"user_image_url": "",
				"signature_url": "",
				"full_name": "Praveen MD Soni"
			},
			"prescription_pdf_url": null,
			"pharmacy_fax_enabled": 0,
			"pharmacy_email_enabled": 0,
			"show_questionnaires_btn": -1,
			"show_consents_btn": -1
		},
		{
			"id": 574,
			"user_id": 11061,
			"clinic_id": 1,
			"type": "laser",
			"doctor_name": "Praveen MD Soni",
			"patient_id": 192,
			"procedure_name": "20200521 004",
			"procedure_date": "2020-05-20 12:02:00",
			"procedure_image": null,
			"procedure_image_45": "1589956383_6s9I_g2B8w8.jpg",
			"consent_ids": "185,189,190,191",
			"note": null,
			"count_flag": null,
			"status": 0,
			"added_from": "",
			"edited_from": "",
			"created": "2020-05-20 12:03:23",
			"modified": "2020-05-21 15:05:44",
			"md_signed": 0,
			"md_signature": null,
			"appointment_id": 0,
			"service_id": 0,
			"invoice_id": 0,
			"sent_to_md": 0,
			"md_user_id": 0,
			"provider_signature": null,
			"provider_signed": 0,
			"save_status": "final",
			"is_consult": 0,
			"is_after_photos": 0,
			"procedure_type": "cosmetic",
			"consultation_fee": 0,
			"procedure_template_id": 0,
			"is_hidden": 0,
			"md_signed_on": "0000-00-00 00:00:00",
			"provider_signed_on": "0000-00-00 00:00:00",
			"after_photos_available": 1,
			"template_used": 1,
			"chief_complaint": null,
			"answers_count": 0,
			"answer_multiples_count": 0,
			"total_price": 0,
			"product_data": [{
				"product_name": "Test by Anup",
				"quantity": 4,
				"unit": "Cycles",
				"product_id": 4870,
				"procedure_id": 574,
				"category_id": "459",
				"price": 0
			}, {
				"product_name": "Test reorder",
				"quantity": "2.0",
				"unit": "Packets",
				"product_id": 4882,
				"procedure_id": 574,
				"category_id": "463",
				"price": 0
			}, {
				"product_name": "Botox Cosmetic 50 Units\/vial",
				"quantity": "0.5",
				"unit": "",
				"product_id": 3202,
				"procedure_id": 574,
				"category_id": "297",
				"price": 0
			}, {
				"product_name": "Botox 200 Units\/vial",
				"quantity": "0.5",
				"unit": "ML",
				"product_id": 3195,
				"procedure_id": 574,
				"category_id": "296",
				"price": 0
			}, {
				"product_name": "CS",
				"quantity": "0.1",
				"unit": "Cycles",
				"product_id": 4869,
				"procedure_id": 574,
				"category_id": "459",
				"price": 0
			}, {
				"product_name": "Display Unit, Lytera",
				"quantity": "0.5",
				"unit": "",
				"product_id": 3310,
				"procedure_id": 574,
				"category_id": "323",
				"price": 0
			}],
			"injection_array": [{
				"product_name": "Test by Anup",
				"quantity": 4,
				"unit": "Cycles",
				"product_id": 4870,
				"procedure_id": 574,
				"price": 0
			}, {
				"product_name": "Test reorder",
				"quantity": "2.0",
				"unit": "Packets",
				"product_id": 4882,
				"procedure_id": 574,
				"price": 0
			}, {
				"product_name": "Botox Cosmetic 50 Units\/vial",
				"quantity": "0.5",
				"unit": "",
				"product_id": 3202,
				"procedure_id": 574,
				"price": 0
			}, {
				"product_name": "Botox 200 Units\/vial",
				"quantity": "0.5",
				"unit": "ML",
				"product_id": 3195,
				"procedure_id": 574,
				"price": 0
			}, {
				"product_name": "CS",
				"quantity": "0.1",
				"unit": "Cycles",
				"product_id": 4869,
				"procedure_id": 574,
				"price": 0
			}, {
				"product_name": "Display Unit, Lytera",
				"quantity": "0.5",
				"unit": "",
				"product_id": 3310,
				"procedure_id": 574,
				"price": 0
			}],
			"total_tax": 0,
			"injections": [{
				"id": 511,
				"procedure_id": 574,
				"product_name": "Test by Anup",
				"quantity": 4,
				"product_id": 4870,
				"product": {
					"id": 4870,
					"toxin_type": "5",
					"price": 0,
					"category_id": "459",
					"product_image_url": ""
				}
			}, {
				"id": 512,
				"procedure_id": 574,
				"product_name": "Test by Anup",
				"quantity": "1.0",
				"product_id": 4870,
				"product": {
					"id": 4870,
					"toxin_type": "5",
					"price": 0,
					"category_id": "459",
					"product_image_url": ""
				}
			}, {
				"id": 513,
				"procedure_id": 574,
				"product_name": "Test by Anup",
				"quantity": "1.0",
				"product_id": 4870,
				"product": {
					"id": 4870,
					"toxin_type": "5",
					"price": 0,
					"category_id": "459",
					"product_image_url": ""
				}
			}, {
				"id": 514,
				"procedure_id": 574,
				"product_name": "Test by Anup",
				"quantity": "1.0",
				"product_id": 4870,
				"product": {
					"id": 4870,
					"toxin_type": "5",
					"price": 0,
					"category_id": "459",
					"product_image_url": ""
				}
			}, {
				"id": 515,
				"procedure_id": 574,
				"product_name": "Test reorder",
				"quantity": "2.0",
				"product_id": 4882,
				"product": {
					"id": 4882,
					"toxin_type": "6",
					"price": 0,
					"category_id": "463",
					"product_image_url": ""
				}
			}, {
				"id": 516,
				"procedure_id": 574,
				"product_name": "Botox Cosmetic 50 Units\/vial",
				"quantity": "0.5",
				"product_id": 3202,
				"product": {
					"id": 3202,
					"toxin_type": "",
					"price": 0,
					"category_id": "297",
					"product_image_url": ""
				}
			}, {
				"id": 517,
				"procedure_id": 574,
				"product_name": "Botox 200 Units\/vial",
				"quantity": "0.5",
				"product_id": 3195,
				"product": {
					"id": 3195,
					"toxin_type": "10",
					"price": 0,
					"category_id": "296",
					"product_image_url": ""
				}
			}, {
				"id": 518,
				"procedure_id": 574,
				"product_name": "CS",
				"quantity": "0.1",
				"product_id": 4869,
				"product": {
					"id": 4869,
					"toxin_type": "5",
					"price": 0,
					"category_id": "459",
					"product_image_url": ""
				}
			}, {
				"id": 519,
				"procedure_id": 574,
				"product_name": "Display Unit, Lytera",
				"quantity": "0.5",
				"product_id": 3310,
				"product": {
					"id": 3310,
					"toxin_type": "",
					"price": 0,
					"category_id": "323",
					"product_image_url": ""
				}
			}],
			"total_image_count": 0,
			"combined_image": null,
			"combined_image_45": "https:\/\/devapi.aestheticrecord.com\/api\/combined-procedure-image\/1937.574.1590053747.jpeg?next=1",
			"survey_appointment_id": null,
			"ba_videos_available": 0,
			"consent_data": [{
				"id": 185,
				"consent_id": 8,
				"signature_image_url": "",
				"signature_thumb_image_url": "",
				"witness_signature_url": "",
				"witness_signature_thumb_image_url": "",
				"created_format_date": "0000-00-00 00:00:00",
				"consent": {
					"id": 8,
					"consent_name": "000 AAA PS Third Consent",
					"consent_small_description": null,
					"consent_large_description": "Vel facilisis volutpat est velit egestas dui id. Nunc sed blandit libero volutpat sed cras ornare arcu dui. Id cursus metus aliquam eleifend mi in. Egestas quis ipsum suspendisse ultrices gravida. Duis at consectetur lorem donec massa sapien. Velit euismod in pellentesque massa placerat. Purus viverra accumsan in nisl nisi scelerisque eu. Nunc congue nisi vitae suscipit tellus mauris. Facilisi nullam vehicula ipsum a arcu cursus. Et ultrices neque ornare aenean euismod elementum.\n\n\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vel fringilla est ullamcorper eget nulla facilisi etiam. Non consectetur a erat nam at lectus urna. Nisl pretium fusce id velit ut tortor pretium viverra suspendisse. Consectetur adipiscing elit duis tristique sollicitudin nibh sit. Ullamcorper velit sed ullamcorper morbi tincidunt ornare massa eget egestas. Mauris commodo quis imperdiet massa tincidunt nunc pulvinar sapien et. Dignissim diam quis enim lobortis scelerisque fermentum dui faucibus. Pulvinar sapien et ligula ullamcorper malesuada proin libero nunc consequat. Tristique magna sit amet purus. Eu augue ut lectus arcu bibendum at varius. Tristique magna sit amet purus gravida. Sed odio morbi quis commodo odio aenean sed adipiscing diam. Amet facilisis magna etiam tempor orci eu. Tellus in metus vulputate eu scelerisque felis imperdiet. Odio morbi quis commodo odio. Dictumst quisque sagittis purus sit amet volutpat consequat mauris nunc.\n\n\n\nVel pretium lectus quam id leo in. At ultrices mi tempus imperdiet nulla. Amet porttitor eget dolor morbi. Ligula ullamcorper malesuada proin libero nunc consequat interdum. Purus ut faucibus pulvinar elementum integer enim neque. Vel pharetra vel turpis nunc eget. Eget mauris pharetra et ultrices neque ornare aenean euismod. Neque aliquam vestibulum morbi blandit. Ut diam quam nulla porttitor massa. Pretium aenean pharetra magna ac placerat vestibulum. Suspendisse interdum consectetur libero id. Fermentum et sollicitudin ac orci phasellus egestas tellus rutrum. Eu augue ut lectus arcu bibendum. Integer eget aliquet nibh praesent tristique magna sit. Tellus cras adipiscing enim eu turpis egestas.\n\n\n\n\n\nAuctor augue mauris augue neque gravida in fermentum et sollicitudin. Id semper risus in hendrerit. Mauris augue neque gravida in fermentum. Eros donec ac odio tempor orci dapibus. Metus dictum at tempor commodo ullamcorper a lacus vestibulum. Orci phasellus egestas tellus rutrum tellus pellentesque. Ut etiam sit amet nisl purus in. Et ultrices neque ornare aenean euismod elementum. Risus commodo viverra maecenas accumsan lacus vel facilisis volutpat est. Nec feugiat in fermentum posuere urna nec tincidunt praesent semper. Enim nulla aliquet porttitor lacus luctus.\n\n\n\nFaucibus in ornare quam viverra orci sagittis eu volutpat odio. Justo nec ultrices dui sapien eget mi. Odio facilisis mauris sit amet. Sit amet commodo nulla facilisi nullam vehicula ipsum. Ut tristique et egestas quis ipsum. Mi eget mauris pharetra et ultrices neque ornare aenean euismod. Tortor id aliquet lectus proin nibh nisl. Eu lobortis elementum nibh tellus molestie nunc. Augue mauris augue neque gravida in fermentum. Quis vel eros donec ac odio tempor orci. Et ultrices neque ornare aenean euismod. Pellentesque massa placerat duis ultricies. Justo eget magna fermentum iaculis eu non diam phasellus vestibulum. In pellentesque massa placerat duis ultricies lacus sed turpis tincidunt. A diam sollicitudin tempor id eu nisl.",
					"added_by": "Praveen Provider Soni",
					"last_edited_by": null,
					"status": 0,
					"created": "2020-04-14 15:28:03",
					"modified": "2020-04-14 15:28:47",
					"order_by": 6,
					"initials_per_page": 0,
					"witness_signature": 1
				}
			}, {
				"id": 189,
				"consent_id": 6,
				"signature_image_url": "",
				"signature_thumb_image_url": "",
				"witness_signature_url": "",
				"witness_signature_thumb_image_url": "",
				"created_format_date": "0000-00-00 00:00:00",
				"consent": {
					"id": 6,
					"consent_name": "000 AAA PS First Consent",
					"consent_small_description": null,
					"consent_large_description": "Vel facilisis volutpat est velit egestas dui id. Nunc sed blandit libero volutpat sed cras ornare arcu dui. Id cursus metus aliquam eleifend mi in. Egestas quis ipsum suspendisse ultrices gravida. Duis at consectetur lorem donec massa sapien. Velit euismod in pellentesque massa placerat. Purus viverra accumsan in nisl nisi scelerisque eu. Nunc congue nisi vitae suscipit tellus mauris. Facilisi nullam vehicula ipsum a arcu cursus. Et ultrices neque ornare aenean euismod elementum.\n\n\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vel fringilla est ullamcorper eget nulla facilisi etiam. Non consectetur a erat nam at lectus urna. Nisl pretium fusce id velit ut tortor pretium viverra suspendisse. Consectetur adipiscing elit duis tristique sollicitudin nibh sit. Ullamcorper velit sed ullamcorper morbi tincidunt ornare massa eget egestas. Mauris commodo quis imperdiet massa tincidunt nunc pulvinar sapien et. Dignissim diam quis enim lobortis scelerisque fermentum dui faucibus. Pulvinar sapien et ligula ullamcorper malesuada proin libero nunc consequat. Tristique magna sit amet purus. Eu augue ut lectus arcu bibendum at varius. Tristique magna sit amet purus gravida. Sed odio morbi quis commodo odio aenean sed adipiscing diam. Amet facilisis magna etiam tempor orci eu. Tellus in metus vulputate eu scelerisque felis imperdiet. Odio morbi quis commodo odio. Dictumst quisque sagittis purus sit amet volutpat consequat mauris nunc.\n\n\n\nVel pretium lectus quam id leo in. At ultrices mi tempus imperdiet nulla. Amet porttitor eget dolor morbi. Ligula ullamcorper malesuada proin libero nunc consequat interdum. Purus ut faucibus pulvinar elementum integer enim neque. Vel pharetra vel turpis nunc eget. Eget mauris pharetra et ultrices neque ornare aenean euismod. Neque aliquam vestibulum morbi blandit. Ut diam quam nulla porttitor massa. Pretium aenean pharetra magna ac placerat vestibulum. Suspendisse interdum consectetur libero id. Fermentum et sollicitudin ac orci phasellus egestas tellus rutrum. Eu augue ut lectus arcu bibendum. Integer eget aliquet nibh praesent tristique magna sit. Tellus cras adipiscing enim eu turpis egestas.\n\n\n\n\n\nAuctor augue mauris augue neque gravida in fermentum et sollicitudin. Id semper risus in hendrerit. Mauris augue neque gravida in fermentum. Eros donec ac odio tempor orci dapibus. Metus dictum at tempor commodo ullamcorper a lacus vestibulum. Orci phasellus egestas tellus rutrum tellus pellentesque. Ut etiam sit amet nisl purus in. Et ultrices neque ornare aenean euismod elementum. Risus commodo viverra maecenas accumsan lacus vel facilisis volutpat est. Nec feugiat in fermentum posuere urna nec tincidunt praesent semper. Enim nulla aliquet porttitor lacus luctus.\n\n\n\nFaucibus in ornare quam viverra orci sagittis eu volutpat odio. Justo nec ultrices dui sapien eget mi. Odio facilisis mauris sit amet. Sit amet commodo nulla facilisi nullam vehicula ipsum. Ut tristique et egestas quis ipsum. Mi eget mauris pharetra et ultrices neque ornare aenean euismod. Tortor id aliquet lectus proin nibh nisl. Eu lobortis elementum nibh tellus molestie nunc. Augue mauris augue neque gravida in fermentum. Quis vel eros donec ac odio tempor orci. Et ultrices neque ornare aenean euismod. Pellentesque massa placerat duis ultricies. Justo eget magna fermentum iaculis eu non diam phasellus vestibulum. In pellentesque massa placerat duis ultricies lacus sed turpis tincidunt. A diam sollicitudin tempor id eu nisl.",
					"added_by": "Praveen Provider Soni",
					"last_edited_by": null,
					"status": 0,
					"created": "2020-04-14 15:26:50",
					"modified": "2020-04-14 15:27:08",
					"order_by": 4,
					"initials_per_page": 0,
					"witness_signature": 0
				}
			}, {
				"id": 190,
				"consent_id": 7,
				"signature_image_url": "",
				"signature_thumb_image_url": "",
				"witness_signature_url": "",
				"witness_signature_thumb_image_url": "",
				"created_format_date": "0000-00-00 00:00:00",
				"consent": {
					"id": 7,
					"consent_name": "000 AAA PS Second Consent",
					"consent_small_description": null,
					"consent_large_description": "Second \n\nAuctor augue mauris augue neque gravida in fermentum et sollicitudin. Id semper risus in hendrerit. Mauris augue neque gravida in fermentum. Eros donec ac odio tempor orci dapibus. Metus dictum at tempor commodo ullamcorper a lacus vestibulum. Orci phasellus egestas tellus rutrum tellus pellentesque. Ut etiam sit amet nisl purus in. Et ultrices neque ornare aenean euismod elementum. Risus commodo viverra maecenas accumsan lacus vel facilisis volutpat est. Nec feugiat in fermentum posuere urna nec tincidunt praesent semper. Enim nulla aliquet porttitor lacus luctus.\n\n\n\nFaucibus in ornare quam viverra orci sagittis eu volutpat odio. Justo nec ultrices dui sapien eget mi. Odio facilisis mauris sit amet. Sit amet commodo nulla facilisi nullam vehicula ipsum. Ut tristique et egestas quis ipsum. Mi eget mauris pharetra et ultrices neque ornare aenean euismod. Tortor id aliquet lectus proin nibh nisl. Eu lobortis elementum nibh tellus molestie nunc. Augue mauris augue neque gravida in fermentum. Quis vel eros donec ac odio tempor orci. Et ultrices neque ornare aenean euismod. Pellentesque massa placerat duis ultricies. Justo eget magna fermentum iaculis eu non diam phasellus vestibulum. In pellentesque massa placerat duis ultricies lacus sed turpis tincidunt. A diam sollicitudin tempor id eu nisl.",
					"added_by": "Praveen Provider Soni",
					"last_edited_by": null,
					"status": 0,
					"created": "2020-04-14 15:27:25",
					"modified": "2020-04-14 15:27:25",
					"order_by": 5,
					"initials_per_page": 1,
					"witness_signature": 0
				}
			}, {
				"id": 191,
				"consent_id": 9,
				"signature_image_url": "",
				"signature_thumb_image_url": "",
				"witness_signature_url": "",
				"witness_signature_thumb_image_url": "",
				"created_format_date": "0000-00-00 00:00:00",
				"consent": {
					"id": 9,
					"consent_name": "000 AAA PS Fourth Consent",
					"consent_small_description": null,
					"consent_large_description": "Vel facilisis volutpat est velit egestas dui id. Nunc sed blandit libero volutpat sed cras ornare arcu dui. Id cursus metus aliquam eleifend mi in. Egestas quis ipsum suspendisse ultrices gravida. Duis at consectetur lorem donec massa sapien. Velit euismod in pellentesque massa placerat. Purus viverra accumsan in nisl nisi scelerisque eu. Nunc congue nisi vitae suscipit tellus mauris. Facilisi nullam vehicula ipsum a arcu cursus. Et ultrices neque ornare aenean euismod elementum.\n\n\n\nLorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Vel fringilla est ullamcorper eget nulla facilisi etiam. Non consectetur a erat nam at lectus urna. Nisl pretium fusce id velit ut tortor pretium viverra suspendisse. Consectetur adipiscing elit duis tristique sollicitudin nibh sit. Ullamcorper velit sed ullamcorper morbi tincidunt ornare massa eget egestas. Mauris commodo quis imperdiet massa tincidunt nunc pulvinar sapien et. Dignissim diam quis enim lobortis scelerisque fermentum dui faucibus. Pulvinar sapien et ligula ullamcorper malesuada proin libero nunc consequat. Tristique magna sit amet purus. Eu augue ut lectus arcu bibendum at varius. Tristique magna sit amet purus gravida. Sed odio morbi quis commodo odio aenean sed adipiscing diam. Amet facilisis magna etiam tempor orci eu. Tellus in metus vulputate eu scelerisque felis imperdiet. Odio morbi quis commodo odio. Dictumst quisque sagittis purus sit amet volutpat consequat mauris nunc.\n\n\n\nVel pretium lectus quam id leo in. At ultrices mi tempus imperdiet nulla. Amet porttitor eget dolor morbi. Ligula ullamcorper malesuada proin libero nunc consequat interdum. Purus ut faucibus pulvinar elementum integer enim neque. Vel pharetra vel turpis nunc eget. Eget mauris pharetra et ultrices neque ornare aenean euismod. Neque aliquam vestibulum morbi blandit. Ut diam quam nulla porttitor massa. Pretium aenean pharetra magna ac placerat vestibulum. Suspendisse interdum consectetur libero id. Fermentum et sollicitudin ac orci phasellus egestas tellus rutrum. Eu augue ut lectus arcu bibendum. Integer eget aliquet nibh praesent tristique magna sit. Tellus cras adipiscing enim eu turpis egestas.\n\n\n\n\n\nAuctor augue mauris augue neque gravida in fermentum et sollicitudin. Id semper risus in hendrerit. Mauris augue neque gravida in fermentum. Eros donec ac odio tempor orci dapibus. Metus dictum at tempor commodo ullamcorper a lacus vestibulum. Orci phasellus egestas tellus rutrum tellus pellentesque. Ut etiam sit amet nisl purus in. Et ultrices neque ornare aenean euismod elementum. Risus commodo viverra maecenas accumsan lacus vel facilisis volutpat est. Nec feugiat in fermentum posuere urna nec tincidunt praesent semper. Enim nulla aliquet porttitor lacus luctus.\n\n\n\nFaucibus in ornare quam viverra orci sagittis eu volutpat odio. Justo nec ultrices dui sapien eget mi. Odio facilisis mauris sit amet. Sit amet commodo nulla facilisi nullam vehicula ipsum. Ut tristique et egestas quis ipsum. Mi eget mauris pharetra et ultrices neque ornare aenean euismod. Tortor id aliquet lectus proin nibh nisl. Eu lobortis elementum nibh tellus molestie nunc. Augue mauris augue neque gravida in fermentum. Quis vel eros donec ac odio tempor orci. Et ultrices neque ornare aenean euismod. Pellentesque massa placerat duis ultricies. Justo eget magna fermentum iaculis eu non diam phasellus vestibulum. In pellentesque massa placerat duis ultricies lacus sed turpis tincidunt. A diam sollicitudin tempor id eu nisl.",
					"added_by": "Praveen Provider Soni",
					"last_edited_by": null,
					"status": 0,
					"created": "2020-04-14 15:28:39",
					"modified": "2020-04-14 15:28:39",
					"order_by": 7,
					"initials_per_page": 1,
					"witness_signature": 1
				}
			}],
			"procedure_questionnaries": [{
				"id": 2,
				"consultation_title": "First Visit Questionairre",
				"status": 0,
				"created": "2017-06-05 09:30:00",
				"modified": "2020-05-17 09:30:00",
				"order_by": 1
			}, {
				"id": 5,
				"consultation_title": "000 AAA PS Cosmetic 001",
				"status": 0,
				"created": "2020-03-31 09:30:00",
				"modified": "2020-03-31 09:30:00",
				"order_by": 3
			}, {
				"id": 6,
				"consultation_title": "000 AAA PS Cosmetic 002",
				"status": 0,
				"created": "2020-03-31 09:30:00",
				"modified": "2020-03-31 09:30:00",
				"order_by": 4
			}, {
				"id": 7,
				"consultation_title": "000 AAA PS Cosmetic 003",
				"status": 0,
				"created": "2020-03-31 09:30:00",
				"modified": "2020-03-31 09:30:00",
				"order_by": 5
			}],
			"can_send_post_instruction": 0,
			"show_consents_btn": 0,
			"procedure_image_thumb_url": "",
			"procedure_image_url": "",
			"procedure_image_45_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1589956383_6s9I_g2B8w8.jpg",
			"procedure_image_45_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1589956383_6s9I_g2B8w8.jpg",
			"procedure_date_new": "2020-05-20",
			"pdf_image": {
				"id": 61,
				"procedure_id": 574,
				"front_pdf_image": "photo1589981986708.jpg",
				"left_pdf_image": null,
				"right_pdf_image": null,
				"left_pdf_image_45": null,
				"right_pdf_image_45": null,
				"back_pdf_image": null,
				"back_pdf_image_left_45": null,
				"back_pdf_image_right_45": null,
				"status": 0,
				"created": "2020-05-20 19:09:50",
				"modified": "2020-05-20 19:09:50",
				"front_pdf_image_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_photo1589981986708.jpg",
				"front_pdf_image_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/photo1589981986708.jpg",
				"left_pdf_image_thumb_url": "",
				"left_pdf_image_url": "",
				"left_pdf_image_45_thumb_url": "",
				"left_pdf_image_45_url": "",
				"right_pdf_image_thumb_url": "",
				"right_pdf_image_url": "",
				"right_pdf_image_45_thumb_url": "",
				"right_pdf_image_45_url": "",
				"back_pdf_image_left_45_thumb_url": "",
				"back_pdf_image_left_45_url": "",
				"back_pdf_image_right_45_thumb_url": "",
				"back_pdf_image_right_45_url": "",
				"back_pdf_image_thumb_url": "",
				"back_pdf_image_url": ""
			},
			"procedure_image_data": {
				"id": 208,
				"procedure_id": 574,
				"patient_image_front": "1589956383_6s9I_g2B8w8.jpg",
				"patient_image_left": null,
				"patient_image_right": null,
				"patient_image_left_45": "1589956388_c0E2yOHHsHU.jpg",
				"patient_image_right_45": "1590053721_osz-FCr7fyY.jpg",
				"patient_image_back": null,
				"patient_image_back_left_45": null,
				"patient_image_back_right_45": null,
				"status": 0,
				"created": "-0001-11-30",
				"modified": "-0001-11-30",
				"patient_image_front_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1589956383_6s9I_g2B8w8.jpg",
				"patient_image_front_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1589956383_6s9I_g2B8w8.jpg",
				"patient_image_left_thumb_url": "",
				"patient_image_left_url": "",
				"patient_image_left_45_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1589956388_c0E2yOHHsHU.jpg",
				"patient_image_left_45_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1589956388_c0E2yOHHsHU.jpg",
				"patient_image_right_thumb_url": "",
				"patient_image_right_url": "",
				"patient_image_right_45_thumb_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/thumb_1590053721_osz-FCr7fyY.jpg",
				"patient_image_right_45_url": "https:\/\/dev-ar-media.s3-us-west-2.amazonaws.com\/d98143a5826228eca6d8ba7290400721\/procedureImages\/1590053721_osz-FCr7fyY.jpg",
				"patient_image_back_left_45_thumb_url": "",
				"patient_image_back_left_45_url": "",
				"patient_image_back_right_45_thumb_url": "",
				"patient_image_back_right_45_url": "",
				"patient_image_back_thumb_url": "",
				"patient_image_back_url": ""
			},
			"pos_invoices": null,
			"clinic": {
				"id": 1,
				"tax": 0
			},
			"user": {
				"id": 11061,
				"firstname": "Praveen MD",
				"lastname": "Soni",
				"signature": "",
				"role_name": "",
				"user_image_url": "",
				"signature_url": "",
				"full_name": "Praveen MD Soni"
			},
			"procedure_notes": [],
			"procedure_information": [],
			"answers": [{
				"id": 1780,
				"procedure_id": 574,
				"consultation_id": 2,
				"question_id": 0,
				"answer": 0,
				"comment": null,
				"status": 0,
				"created": "2020-05-20 12:03:23",
				"modified": "2020-05-20 12:03:23"
			}, {
				"id": 1785,
				"procedure_id": 574,
				"consultation_id": 5,
				"question_id": 0,
				"answer": 0,
				"comment": null,
				"status": 0,
				"created": "2020-05-21 15:05:44",
				"modified": "2020-05-21 15:05:44"
			}, {
				"id": 1786,
				"procedure_id": 574,
				"consultation_id": 7,
				"question_id": 0,
				"answer": 0,
				"comment": null,
				"status": 0,
				"created": "2020-05-21 15:05:44",
				"modified": "2020-05-21 15:05:44"
			}, {
				"id": 1787,
				"procedure_id": 574,
				"consultation_id": 6,
				"question_id": 0,
				"answer": 0,
				"comment": null,
				"status": 0,
				"created": "2020-05-21 15:05:44",
				"modified": "2020-05-21 15:05:44"
			}],
			"answer_multiples": []
		},
		{
			"id": 389,
			"user_id": 11061,
			"clinic_id": 1,
			"type": "face",
			"doctor_name": "Praveen MD Soni",
			"patient_id": 192,
			"procedure_name": "With Consents 002",
			"procedure_date": "2020-04-11 19:44:00",
			"procedure_image": null,
			"procedure_image_45": null,
			"consent_ids": null,
			"note": "Test test test\n\nWe did *** units of ***\r\n\r\n3 Recommendations are:\r\nTemples - 4 Sculptra in 3 months\r\n3 Microneedling spaced 6 weeks\r\nRepeat Botox at 4 months",
			"count_flag": null,
			"status": 0,
			"added_from": "web",
			"edited_from": "",
			"created": "2020-04-11 19:45:15",
			"modified": "2020-04-13 20:25:03",
			"md_signed": 0,
			"md_signature": null,
			"appointment_id": 0,
			"service_id": 0,
			"invoice_id": 0,
			"sent_to_md": 1,
			"md_user_id": 11061,
			"provider_signature": "110611586789700.png",
			"provider_signed": 1,
			"save_status": "final",
			"is_consult": 0,
			"is_after_photos": 0,
			"procedure_type": "health",
			"consultation_fee": 0,
			"procedure_template_id": 5,
			"is_hidden": 0,
			"md_signed_on": "0000-00-00 00:00:00",
			"provider_signed_on": "2020-04-13 20:25:02",
			"after_photos_available": 0,
			"template_used": 0,
			"chief_complaint": null,
			"answers_count": 0,
			"answer_multiples_count": 0,
			"procedure_image_thumb_url": "",
			"procedure_image_url": "",
			"procedure_image_45_thumb_url": "",
			"procedure_image_45_url": "",
			"procedure_date_new": "2020-04-12",
			"appointment": null,
			"clinic": {
				"id": 1,
				"clinic_name": "Your Demo Clinic",
				"contact_no": "+918699153575",
				"city": "MOHALI",
				"address": "Sector17Bus Stand Road 17H",
				"clinic_city": "Chandigarh",
				"clinic_state": "CH",
				"clinic_zipcode": "160022"
			},
			"consents": [{
				"id": 70,
				"procedure_id": 389,
				"consent_id": 2,
				"user_id": 192,
				"created": "2020-04-11 10:15:15",
				"signature_image": null,
				"status": 0,
				"signed_on": "0000-00-00 00:00:00",
				"initials": null,
				"witness_signature": null,
				"is_signed": 0,
				"signature_image_url": "",
				"signature_thumb_image_url": "",
				"witness_signature_url": "",
				"witness_signature_thumb_image_url": "",
				"created_format_date": "2020\/04\/11 07:45 PM",
				"consent": {
					"id": 2,
					"consent_name": "1. BOTULINUM TOXIN INJECTIONS",
					"consent_small_description": "I hereby authorise the provider to perform this procedure. The provider has explained to me the potential benefits and risks of this procedure, the details of the technique, and the materials used. The provider has also explained the possible complications as well as the recovery period. I have received information on the physical and mental consequences of having this procedure.",
					"consent_large_description": "I consent to having my pictures and\/or videos taken and stored in this clinic systems. Such photographs and videos will not be used for any purpose except internal training without my express permission. I understand and agree that all services rendered to me are charged directly to me and that I am personally responsible for payment prior to receiving services. I further agree in the event of non-payment, cancellation of payment or any payment issues, to bear the cost of collection, and\/or the court cost and legal fees, should those be required. I consent to being signed up for the rewards programs so I can earn free points to get discounts on my treatments. I consent to email, text and phone communications related to post procedure care and follow-ups. I am not aware that I am pregnant. I am not trying to get pregnant. I am not lactating (nursing). I do not have or have not had any major illnesses which would prohibit me from receiving this treatment. I certify that I do not have multiple allergies or high sensitivity to medications, including but not limited to lidocaine. I am completely of sound mind and am fully aware of all the risks and possible complications of this procedure. I understand this procedure is one hundred percent voluntary. I acknowledge that no guarantee has been given regarding the results that may be obtained. I have read the material given to me and I am fully satisfied that all of my questions and concerns have been addressed. I understand that I am required to attend post-procedure check-ups as advised by provider and that I am required to follow all post treatment instructions. I have received and fully understand the post treatment instructions. I have advised my provider of my medical history including all previous medical conditions and medications currently being taken. Alternatives to the procedures and options that I am choosing to get today have been fully explained to me. I consent to the administration of such anaesthetics considered necessary or advisable. I understand that all forms of anaesthesia involve risk and the possibility of complications and injury. I am aware that there may be other risks or complications not discussed that may occur. I also understand that during the course of the proposed procedure, unforeseen conditions may be revealed requiring the performance of additional procedures, and I authorize such procedures to be performed. I acknowledge that no guarantees or promises have been made to me concerning the results of this procedure or any treatment that may be required as a result of this procedure. I understand there are no refunds and that multiple treatments are often required to achieve noticeable and lasting outcomes. I also understand that promotional items have no refund value. By accepting and signing, I acknowledge that I have read this informed consent, I understand it, and I agree to the treatment with its associated risks. I hereby give consent to perform this and all subsequent treatments with the above understood. I hereby release the Medical Director(s), the provider performing the treatment and clinic from liability associated with this procedure. I have been given the opportunity to ask questions and my questions have been answered to my satisfaction. I also state that I read and write in English. I hereby consent to the Botulinum Toxin Injection Treatment and hereby authorize the provider to perform the Botulinum Toxin Injection Treatment. I understand that I will be injected with Botulinum A Toxin in the area of the facial muscles to paralyze these muscles temporarily or in the forehead or crow\u00e2\u20ac\u2122s feet around the lateral area of the eyes. I understand my treatment may include both FDA approved locations as well as commonly performed cosmetically treated areas based on desired effects. Botulinum A Toxin injection has been FDA approved for use in the cosmetic treatment for glabellar frown lines \u00e2\u20ac\u201c the wrinkles between the eyebrows and crow\u00e2\u20ac\u2122s feet. I understand there are other risks for the non-FDA approved uses of Botulinum A Toxin. Injection of Botulinum A Toxin into the small muscles between the brows causes those specific muscles to halt their function (be paralyzed), thereby improving the appearance of the wrinkles. I understand the goal is to decrease the wrinkles in the treated area. This paralysis is temporary, and typically lasts three to four months although longevity varies amongst individuals. It has been explained to me that other alternatives are available. The possible side effects of Botulinum A Toxin include but are not limited to: Local numbness, rash, pain at the injection site, flu like symptoms, headache Infection: Infections can occur which in most cases are easily treatable but in rare cases a permanent scarring in the area can occur. Bruising may occur and may last several weeks Most people have lightly swollen pinkish bumps at injection sites for a couple of hours or even several days. Although many people with chronic headaches or migraines often get relief from Botulinum A Toxin, a small percent of patients get headaches following treatment with Botulinum A Toxin, most commonly on the first 1-7 days. In a very small percentage of patients these headaches can persist for several days or weeks. Respiratory problems such as bronchitis or sinusitis, nausea, dizziness, and tightness or irritation of the skin. While local weakness of the injected muscles is representative of the expected pharmacological action of Botulinum A Toxin, weakness of adjacent muscles may occur as a result of the spread of the toxin. Treatments: I understand more than one injection may be needed to achieve a satisfactory result. Another risk when injecting Botulinum A Toxin around the eyes included corneal exposure because people may not be able to blink the eyelids as often as they should to protect the eye. This inability to protect the eye has been associated with damage to the eye as impaired vision, or double vision, which is usually temporary. This reduced blinking has been associated with corneal ulcerations. There are medications that can help lift the eyelid, however, if the drooping is too great the eye drops are not that effective. These side effects can last for several weeks or longer. This occurs in 2-5 percent of patients. I will follow all aftercare instructions as it is crucial I do so for healing. As Botulinum A Toxin injection is not an exact science and facial anatomy and symmetry are highly variable from patient to patient, there might be an uneven appearance of the face with some muscles more affected by the Botulinum A Toxin than others. In most cases this uneven appearance can sometimes be corrected by injecting Botulinum A Toxin in the same or nearby muscles. However in some cases this uneven appearance can persist for several weeks or months until the full effects of the product have subsided. This list is not meant to be inclusive of all possible risks associated with Botulinum A Toxin as there are both known and unknown side effects associated with any medication or procedure. Botulinum A Toxin should not be administered to a pregnant or nursing woman. Additionally, the number of units injected is an estimate of the amount of Botulinum A Toxin required to paralyze the muscles. I understand there is no guarantee of results of any treatment. As with all injectable treatments, there is a risk of infection, vessel occlusion, granulomas, abscess formation and hypersensitive reaction. Approved Uses BOTOX\u00c2\u00ae Cosmetic is a prescription medicine that is injected into muscles and used to temporarily improve the look of both moderate to severe crow\u00e2\u20ac\u2122s feet lines and frown lines between the eyebrows in adults. IMPORTANT SAFETY INFORMATION BOTOX\u00c2\u00ae Cosmetic may cause serious side effects that can be life threatening. Get medical help right away if you have any of these problems any time (hours to weeks) after injection of BOTOX\u00c2\u00ae Cosmetic: Problems swallowing, speaking, or breathing, due to weakening of associated muscles, can be severe and result in loss of life. You are at the highest risk if these problems are pre-existing before injection. Swallowing problems may last for several months Spread of toxin effects. The effect of botulinum toxin may affect areas away from the injection site and cause serious symptoms including: loss of strength and Approved Uses BOTOX\u00c2\u00ae Cosmetic is a prescription medicine that is injected into muscles and used to temporarily improve the look of both moderate to severe crow\u00e2\u20ac\u2122s feet lines and frown lines between the eyebrows in adults. IMPORTANT SAFETY INFORMATION BOTOX\u00c2\u00ae Cosmetic may cause serious side effects that can be life threatening. Get medical help right away if you have any of these problems any time (hours to weeks) after injection of BOTOX\u00c2\u00ae Cosmetic: Problems swallowing, speaking, or breathing, due to weakening of associated muscles, can be severe and result in loss of life. You are at the highest risk if these problems are pre-existing before injection. Swallowing problems may last for several months Spread of toxin effects. The effect of botulinum toxin may affect areas away from the injection site and cause serious symptoms including: loss of strength and all-over muscle weakness, double vision, blurred vision and drooping eyelids, hoarseness or change or loss of voice, trouble saying words clearly, loss of bladder control, trouble breathing, trouble swallowing BOTOX\u00c2\u00ae Cosmetic dosing units are not the same as, or comparable to, any other botulinum toxin product. There has not been a confirmed serious case of spread of toxin effect when BOTOX\u00c2\u00ae Cosmetic has been used at the recommended dose to treat frown lines, crow\u00e2\u20ac\u2122s feet lines, or both at the same time. BOTOX\u00c2\u00ae Cosmetic may cause loss of strength or general muscle weakness, vision problems, or dizziness within hours to weeks of taking BOTOX\u00c2\u00ae Cosmetic. If this happens, do not drive a car, operate machinery, or do other dangerous activities. Serious and\/or immediate allergic reactions have been reported. They include: itching, rash, red itchy welts, wheezing, asthma symptoms, or dizziness or feeling faint. Get medical help right away if you are wheezing or have asthma symptoms, or if you become dizzy or faint. Do not take BOTOX\u00c2\u00ae Cosmetic if you: are allergic to any of the ingredients in BOTOX\u00c2\u00ae Cosmetic (see Medication Guide for ingredients); had an allergic reaction to any other botulinum toxin product such as Myobloc\u00c2\u00ae (rimabotulinumtoxinB), Dysport\u00c2\u00ae (abobotulinumtoxinA), or Xeomin\u00c2\u00ae (incobotulinumtoxinA); have a skin infection at the planned injection site. Tell your doctor about all your muscle or nerve conditions, such as ALS or Lou Gehrig\u00e2\u20ac\u2122s disease, myasthenia gravis, or Lambert-Eaton syndrome, as you may be at increased risk of serious side effects including difficulty swallowing and difficulty breathing from typical doses of BOTOX\u00c2\u00ae Cosmetic. Tell your doctor about all your medical conditions, including: plans to have surgery; had surgery on your face; weakness of forehead muscles: trouble raising your eyebrows; drooping eyelids; any other abnormal facial change; are pregnant or plan to become pregnant (it is not known if BOTOX\u00c2\u00ae Cosmetic can harm your unborn baby); are breast-feeding or plan to (it is not known if BOTOX\u00c2\u00ae Cosmetic passes into breast milk). Tell your doctor about all the medicines you take, including prescription and nonprescription medicines, vitamins, and herbal products. Using BOTOX\u00c2\u00ae Cosmetic with certain other medicines may cause serious side effects. Do not start any new medicines until you have told your doctor that you have received BOTOX\u00c2\u00ae Cosmetic in the past. Tell your doctor if you have received any other botulinum toxin product in the last 4 months; have received injections of botulinum toxin such as Myobloc\u00c2\u00ae, Dysport\u00c2\u00ae, or Xeomin\u00c2\u00ae in the past (tell your doctor exactly which product you received); have recently received an antibiotic by injection; take muscle relaxants; take an allergy or cold medicine; take a sleep medicine; take aspirin-like products or blood thinners. Other side effects of BOTOX\u00c2\u00ae Cosmetic include: discomfort or pain at the injection site; headache; and eye problems: double vision, blurred vision, drooping eyelids, and swelling of your eyelids.",
					"added_by": "Admin",
					"last_edited_by": "Admin",
					"status": 0,
					"created": "2017-06-05 19:03:48",
					"modified": "2017-06-07 01:11:45",
					"order_by": 0,
					"initials_per_page": 0,
					"witness_signature": 0
				}
			}],
			"procedure_prescription": [],
			"procedure_notes": [],
			"pos_invoices": null,
			"user": {
				"id": 11061,
				"clinic_id": 1,
				"user_role_id": 4,
				"is_provider": true,
				"account_id": 1937,
				"supplementary_title": null,
				"firstname": "Praveen MD",
				"lastname": "Soni",
				"email_id": "praveen.md.kiran@yopmail.com",
				"pass_code": 9102,
				"signature": "",
				"website": null,
				"contact_number_1": null,
				"contact_number_2": null,
				"contact_number_3": null,
				"contact_number_4": null,
				"address_line_1": null,
				"address_line_2": null,
				"address_line_3": null,
				"address_line_4": null,
				"pincode": null,
				"city": "Mohali",
				"state": "Punjab",
				"country": "India",
				"user_image": null,
				"status": "Active",
				"session_id": "",
				"web_session_id": "9eec033f6000826b016403da5c7f0d82",
				"last_login_ip": "2405:201:5200:676d:6c62:b16c:e09b:2f80",
				"last_login_date": "2020-05-20 11:58:10",
				"created": "2020-01-01 12:35:51",
				"modified": "2020-05-20",
				"password_flag": 0,
				"monthly_procedure_goal": 100,
				"weekly_procedure_goal": 20,
				"monthly_sales_goal": 200,
				"weekly_sales_goal": 40,
				"is_md_consent_required": true,
				"timezone": "Asia\/Kolkata",
				"appointment_color": "#E15D44",
				"vacation_mode": 0,
				"vacation_startdate": "0000-00-00",
				"vacation_enddate": "0000-00-00",
				"last_activity": "2020-02-12 17:07:03",
				"web_last_activity": "2020-05-20 12:11:18",
				"bio_name": "PS MD",
				"bio_title": "PS MD",
				"bio_description": "PS MD",
				"gender": null,
				"dob": "0000-00-00",
				"is_available_online": true,
				"md_user_id": 11061,
				"show_signature_popup": true,
				"is_dashboard_enabled": true,
				"display_order": 2,
				"is_demo": 0,
				"commission_percentage": 10,
				"receive_checkin_sms": 0,
				"app_version": "8.10.2",
				"email_id_2": null,
				"email_id_3": null,
				"cash_drawer_notification": 1,
				"super_account_id": 0,
				"super_user": 0,
				"degree_designation": "NP",
				"hourly_rate": 5,
				"procedure_steps": null,
				"state_license": null,
				"dea": null,
				"npi": null,
				"medicaid_upin": null,
				"role_name": "md",
				"user_image_url": "",
				"signature_url": "",
				"full_name": "Praveen MD Soni"
			},
			"prescription_pdf_url": null,
			"pharmacy_fax_enabled": 0,
			"pharmacy_email_enabled": 0,
			"show_questionnaires_btn": 1,
			"show_consents_btn": 0
		},
		{
			"id": 382,
			"user_id": 11061,
			"clinic_id": 1,
			"type": "face",
			"doctor_name": "Praveen MD Soni",
			"patient_id": 192,
			"procedure_name": "sdfsfas",
			"procedure_date": "2020-04-10 14:04:00",
			"procedure_image": null,
			"procedure_image_45": null,
			"consent_ids": null,
			"note": "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.",
			"count_flag": null,
			"status": 0,
			"added_from": "web",
			"edited_from": "",
			"created": "2020-04-10 14:04:46",
			"modified": "2020-04-10 14:05:33",
			"md_signed": 1,
			"md_signature": "110611586507731.png",
			"appointment_id": 0,
			"service_id": 0,
			"invoice_id": 0,
			"sent_to_md": 1,
			"md_user_id": 11061,
			"provider_signature": "110611586507712.png",
			"provider_signed": 1,
			"save_status": "final",
			"is_consult": 0,
			"is_after_photos": 0,
			"procedure_type": "health",
			"consultation_fee": 0,
			"procedure_template_id": 0,
			"is_hidden": 0,
			"md_signed_on": "2020-04-10 14:05:33",
			"provider_signed_on": "2020-04-10 14:05:14",
			"after_photos_available": 0,
			"template_used": 0,
			"chief_complaint": null,
			"answers_count": 0,
			"answer_multiples_count": 0,
			"procedure_image_thumb_url": "",
			"procedure_image_url": "",
			"procedure_image_45_thumb_url": "",
			"procedure_image_45_url": "",
			"procedure_date_new": "2020-04-10",
			"appointment": null,
			"clinic": {
				"id": 1,
				"clinic_name": "Your Demo Clinic",
				"contact_no": "+918699153575",
				"city": "MOHALI",
				"address": "Sector17Bus Stand Road 17H",
				"clinic_city": "Chandigarh",
				"clinic_state": "CH",
				"clinic_zipcode": "160022"
			},
			"consents": [{
				"id": 65,
				"procedure_id": 382,
				"consent_id": 3,
				"user_id": 192,
				"created": "2020-04-10 04:34:46",
				"signature_image": null,
				"status": 0,
				"signed_on": "0000-00-00 00:00:00",
				"initials": null,
				"witness_signature": null,
				"is_signed": 0,
				"signature_image_url": "",
				"signature_thumb_image_url": "",
				"witness_signature_url": "",
				"witness_signature_thumb_image_url": "",
				"created_format_date": "2020\/04\/10 02:04 PM",
				"consent": {
					"id": 3,
					"consent_name": "C1",
					"consent_small_description": "I hereby authorise the provider to perform this procedure. The provider has explained to me the potential benefits and risks of this procedure, the details of the technique, and the materials used. The provider has also explained the possible complications as well as the recovery period. I have received information on the physical and mental consequences of having this procedure.",
					"consent_large_description": "I consent to having my pictures and\/or videos taken and stored in this clinic systems. Such photographs and videos will not be used for any purpose except internal training without my express permission. I understand and agree that all services rendered to me are charged directly to me and that I am personally responsible for payment prior to receiving services. I further agree in the event of non-payment, cancellation of payment or any payment issues, to bear the cost of collection, and\/or the court cost and legal fees, should those be required. I consent to being signed up for the rewards programs so I can earn free points to get discounts on my treatments. I consent to email, text and phone communications related to post procedure care and follow-ups. I am not aware that I am pregnant. I am not trying to get pregnant. I am not lactating (nursing). I do not have or have not had any major illnesses which would prohibit me from receiving this treatment. I certify that I do not have multiple allergies or high sensitivity to medications, including but not limited to lidocaine. I am completely of sound mind and am fully aware of all the risks and possible complications of this procedure. I understand this procedure is one hundred percent voluntary. I acknowledge that no guarantee has been given regarding the results that may be obtained. I have read the material given to me and I am fully satisfied that all of my questions and concerns have been addressed. I understand that I am required to attend post-procedure check-ups as advised by provider and that I am required to follow all post treatment instructions. I have received and fully understand the post treatment instructions. I have advised my provider of my medical history including all previous medical conditions and medications currently being taken. Alternatives to the procedures and options that I am choosing to get today have been fully explained to me. I consent to the administration of such anaesthetics considered necessary or advisable. I understand that all forms of anaesthesia involve risk and the possibility of complications and injury. I am aware that there may be other risks or complications not discussed that may occur. I also understand that during the course of the proposed procedure, unforeseen conditions may be revealed requiring the performance of additional procedures, and I authorize such procedures to be performed. I acknowledge that no guarantees or promises have been made to me concerning the results of this procedure or any treatment that may be required as a result of this procedure. I understand there are no refunds and that multiple treatments are often required to achieve noticeable and lasting outcomes. I also understand that promotional items have no refund value. By accepting and signing, I acknowledge that I have read this informed consent, I understand it, and I agree to the treatment with its associated risks. I hereby give consent to perform this and all subsequent treatments with the above understood. I hereby release the Medical Director(s), the provider performing the treatment and clinic from liability associated with this procedure. I have been given the opportunity to ask questions and my questions have been answered to my satisfaction. I also state that I read and write in English. I hereby consent to the Botulinum Toxin Injection Treatment and hereby authorize the provider to perform the Botulinum Toxin Injection Treatment. I understand that I will be injected with Botulinum A Toxin in the area of the facial muscles to paralyze these muscles temporarily or in the forehead or crow\u00e2\u20ac\u2122s feet around the lateral area of the eyes. I understand my treatment may include both FDA approved locations as well as commonly performed cosmetically treated areas based on desired effects. Botulinum A Toxin injection has been FDA approved for use in the cosmetic treatment for glabellar frown lines \u00e2\u20ac\u201c the wrinkles between the eyebrows and crow\u00e2\u20ac\u2122s feet. I understand there are other risks for the non-FDA approved uses of Botulinum A Toxin. Injection of Botulinum A Toxin into the small muscles between the brows causes those specific muscles to halt their function (be paralyzed), thereby improving the appearance of the wrinkles. I understand the goal is to decrease the wrinkles in the treated area. This paralysis is temporary, and typically lasts three to four months although longevity varies amongst individuals. It has been explained to me that other alternatives are available. The possible side effects of Botulinum A Toxin include but are not limited to: Local numbness, rash, pain at the injection site, flu like symptoms, headache Infection: Infections can occur which in most cases are easily treatable but in rare cases a permanent scarring in the area can occur. Bruising may occur and may last several weeks Most people have lightly swollen pinkish bumps at injection sites for a couple of hours or even several days. Although many people with chronic headaches or migraines often get relief from Botulinum A Toxin, a small percent of patients get headaches following treatment with Botulinum A Toxin, most commonly on the first 1-7 days. In a very small percentage of patients these headaches can persist for several days or weeks. Respiratory problems such as bronchitis or sinusitis, nausea, dizziness, and tightness or irritation of the skin. While local weakness of the injected muscles is representative of the expected pharmacological action of Botulinum A Toxin, weakness of adjacent muscles may occur as a result of the spread of the toxin. Treatments: I understand more than one injection may be needed to achieve a satisfactory result. Another risk when injecting Botulinum A Toxin around the eyes included corneal exposure because people may not be able to blink the eyelids as often as they should to protect the eye. This inability to protect the eye has been associated with damage to the eye as impaired vision, or double vision, which is usually temporary. This reduced blinking has been associated with corneal ulcerations. There are medications that can help lift the eyelid, however, if the drooping is too great the eye drops are not that effective. These side effects can last for several weeks or longer. This occurs in 2-5 percent of patients. I will follow all aftercare instructions as it is crucial I do so for healing. As Botulinum A Toxin injection is not an exact science and facial anatomy and symmetry are highly variable from patient to patient, there might be an uneven appearance of the face with some muscles more affected by the Botulinum A Toxin than others. In most cases this uneven appearance can sometimes be corrected by injecting Botulinum A Toxin in the same or nearby muscles. However in some cases this uneven appearance can persist for several weeks or months until the full effects of the product have subsided. This list is not meant to be inclusive of all possible risks associated with Botulinum A Toxin as there are both known and unknown side effects associated with any medication or procedure. Botulinum A Toxin should not be administered to a pregnant or nursing woman. Additionally, the number of units injected is an estimate of the amount of Botulinum A Toxin required to paralyze the muscles. I understand there is no guarantee of results of any treatment. As with all injectable treatments, there is a risk of infection, vessel occlusion, granulomas, abscess formation and hypersensitive reaction. Approved Uses BOTOX\u00c2\u00ae Cosmetic is a prescription medicine that is injected into muscles and used to temporarily improve the look of both moderate to severe crow\u00e2\u20ac\u2122s feet lines and frown lines between the eyebrows in adults. IMPORTANT SAFETY INFORMATION BOTOX\u00c2\u00ae Cosmetic may cause serious side effects that can be life threatening. Get medical help right away if you have any of these problems any time (hours to weeks) after injection of BOTOX\u00c2\u00ae Cosmetic: Problems swallowing, speaking, or breathing, due to weakening of associated muscles, can be severe and result in loss of life. You are at the highest risk if these problems are pre-existing before injection. Swallowing problems may last for several months Spread of toxin effects. The effect of botulinum toxin may affect areas away from the injection site and cause serious symptoms including: loss of strength and Approved Uses BOTOX\u00c2\u00ae Cosmetic is a prescription medicine that is injected into muscles and used to temporarily improve the look of both moderate to severe crow\u00e2\u20ac\u2122s feet lines and frown lines between the eyebrows in adults. IMPORTANT SAFETY INFORMATION BOTOX\u00c2\u00ae Cosmetic may cause serious side effects that can be life threatening. Get medical help right away if you have any of these problems any time (hours to weeks) after injection of BOTOX\u00c2\u00ae Cosmetic: Problems swallowing, speaking, or breathing, due to weakening of associated muscles, can be severe and result in loss of life. You are at the highest risk if these problems are pre-existing before injection. Swallowing problems may last for several months Spread of toxin effects. The effect of botulinum toxin may affect areas away from the injection site and cause serious symptoms including: loss of strength and all-over muscle weakness, double vision, blurred vision and drooping eyelids, hoarseness or change or loss of voice, trouble saying words clearly, loss of bladder control, trouble breathing, trouble swallowing BOTOX\u00c2\u00ae Cosmetic dosing units are not the same as, or comparable to, any other botulinum toxin product. There has not been a confirmed serious case of spread of toxin effect when BOTOX\u00c2\u00ae Cosmetic has been used at the recommended dose to treat frown lines, crow\u00e2\u20ac\u2122s feet lines, or both at the same time. BOTOX\u00c2\u00ae Cosmetic may cause loss of strength or general muscle weakness, vision problems, or dizziness within hours to weeks of taking BOTOX\u00c2\u00ae Cosmetic. If this happens, do not drive a car, operate machinery, or do other dangerous activities. Serious and\/or immediate allergic reactions have been reported. They include: itching, rash, red itchy welts, wheezing, asthma symptoms, or dizziness or feeling faint. Get medical help right away if you are wheezing or have asthma symptoms, or if you become dizzy or faint. Do not take BOTOX\u00c2\u00ae Cosmetic if you: are allergic to any of the ingredients in BOTOX\u00c2\u00ae Cosmetic (see Medication Guide for ingredients); had an allergic reaction to any other botulinum toxin product such as Myobloc\u00c2\u00ae (rimabotulinumtoxinB), Dysport\u00c2\u00ae (abobotulinumtoxinA), or Xeomin\u00c2\u00ae (incobotulinumtoxinA); have a skin infection at the planned injection site. Tell your doctor about all your muscle or nerve conditions, such as ALS or Lou Gehrig\u00e2\u20ac\u2122s disease, myasthenia gravis, or Lambert-Eaton syndrome, as you may be at increased risk of serious side effects including difficulty swallowing and difficulty breathing from typical doses of BOTOX\u00c2\u00ae Cosmetic. Tell your doctor about all your medical conditions, including: plans to have surgery; had surgery on your face; weakness of forehead muscles: trouble raising your eyebrows; drooping eyelids; any other abnormal facial change; are pregnant or plan to become pregnant (it is not known if BOTOX\u00c2\u00ae Cosmetic can harm your unborn baby); are breast-feeding or plan to (it is not known if BOTOX\u00c2\u00ae Cosmetic passes into breast milk). Tell your doctor about all the medicines you take, including prescription and nonprescription medicines, vitamins, and herbal products. Using BOTOX\u00c2\u00ae Cosmetic with certain other medicines may cause serious side effects. Do not start any new medicines until you have told your doctor that you have received BOTOX\u00c2\u00ae Cosmetic in the past. Tell your doctor if you have received any other botulinum toxin product in the last 4 months; have received injections of botulinum toxin such as Myobloc\u00c2\u00ae, Dysport\u00c2\u00ae, or Xeomin\u00c2\u00ae in the past (tell your doctor exactly which product you received); have recently received an antibiotic by injection; take muscle relaxants; take an allergy or cold medicine; take a sleep medicine; take aspirin-like products or blood thinners. Other side effects of BOTOX\u00c2\u00ae Cosmetic include: discomfort or pain at the injection site; headache; and eye problems: double vision, blurred vision, drooping eyelids, and swelling of your eyelids.",
					"added_by": "Kiranjot Kaur Gambhir",
					"last_edited_by": null,
					"status": 0,
					"created": "2020-01-07 14:15:03",
					"modified": "2020-01-07 14:15:03",
					"order_by": 1,
					"initials_per_page": 1,
					"witness_signature": 1
				}
			}, {
				"id": 66,
				"procedure_id": 382,
				"consent_id": 2,
				"user_id": 192,
				"created": "2020-04-10 04:34:46",
				"signature_image": null,
				"status": 0,
				"signed_on": "0000-00-00 00:00:00",
				"initials": null,
				"witness_signature": null,
				"is_signed": 0,
				"signature_image_url": "",
				"signature_thumb_image_url": "",
				"witness_signature_url": "",
				"witness_signature_thumb_image_url": "",
				"created_format_date": "2020\/04\/10 02:04 PM",
				"consent": {
					"id": 2,
					"consent_name": "1. BOTULINUM TOXIN INJECTIONS",
					"consent_small_description": "I hereby authorise the provider to perform this procedure. The provider has explained to me the potential benefits and risks of this procedure, the details of the technique, and the materials used. The provider has also explained the possible complications as well as the recovery period. I have received information on the physical and mental consequences of having this procedure.",
					"consent_large_description": "I consent to having my pictures and\/or videos taken and stored in this clinic systems. Such photographs and videos will not be used for any purpose except internal training without my express permission. I understand and agree that all services rendered to me are charged directly to me and that I am personally responsible for payment prior to receiving services. I further agree in the event of non-payment, cancellation of payment or any payment issues, to bear the cost of collection, and\/or the court cost and legal fees, should those be required. I consent to being signed up for the rewards programs so I can earn free points to get discounts on my treatments. I consent to email, text and phone communications related to post procedure care and follow-ups. I am not aware that I am pregnant. I am not trying to get pregnant. I am not lactating (nursing). I do not have or have not had any major illnesses which would prohibit me from receiving this treatment. I certify that I do not have multiple allergies or high sensitivity to medications, including but not limited to lidocaine. I am completely of sound mind and am fully aware of all the risks and possible complications of this procedure. I understand this procedure is one hundred percent voluntary. I acknowledge that no guarantee has been given regarding the results that may be obtained. I have read the material given to me and I am fully satisfied that all of my questions and concerns have been addressed. I understand that I am required to attend post-procedure check-ups as advised by provider and that I am required to follow all post treatment instructions. I have received and fully understand the post treatment instructions. I have advised my provider of my medical history including all previous medical conditions and medications currently being taken. Alternatives to the procedures and options that I am choosing to get today have been fully explained to me. I consent to the administration of such anaesthetics considered necessary or advisable. I understand that all forms of anaesthesia involve risk and the possibility of complications and injury. I am aware that there may be other risks or complications not discussed that may occur. I also understand that during the course of the proposed procedure, unforeseen conditions may be revealed requiring the performance of additional procedures, and I authorize such procedures to be performed. I acknowledge that no guarantees or promises have been made to me concerning the results of this procedure or any treatment that may be required as a result of this procedure. I understand there are no refunds and that multiple treatments are often required to achieve noticeable and lasting outcomes. I also understand that promotional items have no refund value. By accepting and signing, I acknowledge that I have read this informed consent, I understand it, and I agree to the treatment with its associated risks. I hereby give consent to perform this and all subsequent treatments with the above understood. I hereby release the Medical Director(s), the provider performing the treatment and clinic from liability associated with this procedure. I have been given the opportunity to ask questions and my questions have been answered to my satisfaction. I also state that I read and write in English. I hereby consent to the Botulinum Toxin Injection Treatment and hereby authorize the provider to perform the Botulinum Toxin Injection Treatment. I understand that I will be injected with Botulinum A Toxin in the area of the facial muscles to paralyze these muscles temporarily or in the forehead or crow\u00e2\u20ac\u2122s feet around the lateral area of the eyes. I understand my treatment may include both FDA approved locations as well as commonly performed cosmetically treated areas based on desired effects. Botulinum A Toxin injection has been FDA approved for use in the cosmetic treatment for glabellar frown lines \u00e2\u20ac\u201c the wrinkles between the eyebrows and crow\u00e2\u20ac\u2122s feet. I understand there are other risks for the non-FDA approved uses of Botulinum A Toxin. Injection of Botulinum A Toxin into the small muscles between the brows causes those specific muscles to halt their function (be paralyzed), thereby improving the appearance of the wrinkles. I understand the goal is to decrease the wrinkles in the treated area. This paralysis is temporary, and typically lasts three to four months although longevity varies amongst individuals. It has been explained to me that other alternatives are available. The possible side effects of Botulinum A Toxin include but are not limited to: Local numbness, rash, pain at the injection site, flu like symptoms, headache Infection: Infections can occur which in most cases are easily treatable but in rare cases a permanent scarring in the area can occur. Bruising may occur and may last several weeks Most people have lightly swollen pinkish bumps at injection sites for a couple of hours or even several days. Although many people with chronic headaches or migraines often get relief from Botulinum A Toxin, a small percent of patients get headaches following treatment with Botulinum A Toxin, most commonly on the first 1-7 days. In a very small percentage of patients these headaches can persist for several days or weeks. Respiratory problems such as bronchitis or sinusitis, nausea, dizziness, and tightness or irritation of the skin. While local weakness of the injected muscles is representative of the expected pharmacological action of Botulinum A Toxin, weakness of adjacent muscles may occur as a result of the spread of the toxin. Treatments: I understand more than one injection may be needed to achieve a satisfactory result. Another risk when injecting Botulinum A Toxin around the eyes included corneal exposure because people may not be able to blink the eyelids as often as they should to protect the eye. This inability to protect the eye has been associated with damage to the eye as impaired vision, or double vision, which is usually temporary. This reduced blinking has been associated with corneal ulcerations. There are medications that can help lift the eyelid, however, if the drooping is too great the eye drops are not that effective. These side effects can last for several weeks or longer. This occurs in 2-5 percent of patients. I will follow all aftercare instructions as it is crucial I do so for healing. As Botulinum A Toxin injection is not an exact science and facial anatomy and symmetry are highly variable from patient to patient, there might be an uneven appearance of the face with some muscles more affected by the Botulinum A Toxin than others. In most cases this uneven appearance can sometimes be corrected by injecting Botulinum A Toxin in the same or nearby muscles. However in some cases this uneven appearance can persist for several weeks or months until the full effects of the product have subsided. This list is not meant to be inclusive of all possible risks associated with Botulinum A Toxin as there are both known and unknown side effects associated with any medication or procedure. Botulinum A Toxin should not be administered to a pregnant or nursing woman. Additionally, the number of units injected is an estimate of the amount of Botulinum A Toxin required to paralyze the muscles. I understand there is no guarantee of results of any treatment. As with all injectable treatments, there is a risk of infection, vessel occlusion, granulomas, abscess formation and hypersensitive reaction. Approved Uses BOTOX\u00c2\u00ae Cosmetic is a prescription medicine that is injected into muscles and used to temporarily improve the look of both moderate to severe crow\u00e2\u20ac\u2122s feet lines and frown lines between the eyebrows in adults. IMPORTANT SAFETY INFORMATION BOTOX\u00c2\u00ae Cosmetic may cause serious side effects that can be life threatening. Get medical help right away if you have any of these problems any time (hours to weeks) after injection of BOTOX\u00c2\u00ae Cosmetic: Problems swallowing, speaking, or breathing, due to weakening of associated muscles, can be severe and result in loss of life. You are at the highest risk if these problems are pre-existing before injection. Swallowing problems may last for several months Spread of toxin effects. The effect of botulinum toxin may affect areas away from the injection site and cause serious symptoms including: loss of strength and Approved Uses BOTOX\u00c2\u00ae Cosmetic is a prescription medicine that is injected into muscles and used to temporarily improve the look of both moderate to severe crow\u00e2\u20ac\u2122s feet lines and frown lines between the eyebrows in adults. IMPORTANT SAFETY INFORMATION BOTOX\u00c2\u00ae Cosmetic may cause serious side effects that can be life threatening. Get medical help right away if you have any of these problems any time (hours to weeks) after injection of BOTOX\u00c2\u00ae Cosmetic: Problems swallowing, speaking, or breathing, due to weakening of associated muscles, can be severe and result in loss of life. You are at the highest risk if these problems are pre-existing before injection. Swallowing problems may last for several months Spread of toxin effects. The effect of botulinum toxin may affect areas away from the injection site and cause serious symptoms including: loss of strength and all-over muscle weakness, double vision, blurred vision and drooping eyelids, hoarseness or change or loss of voice, trouble saying words clearly, loss of bladder control, trouble breathing, trouble swallowing BOTOX\u00c2\u00ae Cosmetic dosing units are not the same as, or comparable to, any other botulinum toxin product. There has not been a confirmed serious case of spread of toxin effect when BOTOX\u00c2\u00ae Cosmetic has been used at the recommended dose to treat frown lines, crow\u00e2\u20ac\u2122s feet lines, or both at the same time. BOTOX\u00c2\u00ae Cosmetic may cause loss of strength or general muscle weakness, vision problems, or dizziness within hours to weeks of taking BOTOX\u00c2\u00ae Cosmetic. If this happens, do not drive a car, operate machinery, or do other dangerous activities. Serious and\/or immediate allergic reactions have been reported. They include: itching, rash, red itchy welts, wheezing, asthma symptoms, or dizziness or feeling faint. Get medical help right away if you are wheezing or have asthma symptoms, or if you become dizzy or faint. Do not take BOTOX\u00c2\u00ae Cosmetic if you: are allergic to any of the ingredients in BOTOX\u00c2\u00ae Cosmetic (see Medication Guide for ingredients); had an allergic reaction to any other botulinum toxin product such as Myobloc\u00c2\u00ae (rimabotulinumtoxinB), Dysport\u00c2\u00ae (abobotulinumtoxinA), or Xeomin\u00c2\u00ae (incobotulinumtoxinA); have a skin infection at the planned injection site. Tell your doctor about all your muscle or nerve conditions, such as ALS or Lou Gehrig\u00e2\u20ac\u2122s disease, myasthenia gravis, or Lambert-Eaton syndrome, as you may be at increased risk of serious side effects including difficulty swallowing and difficulty breathing from typical doses of BOTOX\u00c2\u00ae Cosmetic. Tell your doctor about all your medical conditions, including: plans to have surgery; had surgery on your face; weakness of forehead muscles: trouble raising your eyebrows; drooping eyelids; any other abnormal facial change; are pregnant or plan to become pregnant (it is not known if BOTOX\u00c2\u00ae Cosmetic can harm your unborn baby); are breast-feeding or plan to (it is not known if BOTOX\u00c2\u00ae Cosmetic passes into breast milk). Tell your doctor about all the medicines you take, including prescription and nonprescription medicines, vitamins, and herbal products. Using BOTOX\u00c2\u00ae Cosmetic with certain other medicines may cause serious side effects. Do not start any new medicines until you have told your doctor that you have received BOTOX\u00c2\u00ae Cosmetic in the past. Tell your doctor if you have received any other botulinum toxin product in the last 4 months; have received injections of botulinum toxin such as Myobloc\u00c2\u00ae, Dysport\u00c2\u00ae, or Xeomin\u00c2\u00ae in the past (tell your doctor exactly which product you received); have recently received an antibiotic by injection; take muscle relaxants; take an allergy or cold medicine; take a sleep medicine; take aspirin-like products or blood thinners. Other side effects of BOTOX\u00c2\u00ae Cosmetic include: discomfort or pain at the injection site; headache; and eye problems: double vision, blurred vision, drooping eyelids, and swelling of your eyelids.",
					"added_by": "Admin",
					"last_edited_by": "Admin",
					"status": 0,
					"created": "2017-06-05 19:03:48",
					"modified": "2017-06-07 01:11:45",
					"order_by": 0,
					"initials_per_page": 0,
					"witness_signature": 0
				}
			}, {
				"id": 67,
				"procedure_id": 382,
				"consent_id": 4,
				"user_id": 192,
				"created": "2020-04-10 04:34:46",
				"signature_image": null,
				"status": 0,
				"signed_on": "0000-00-00 00:00:00",
				"initials": null,
				"witness_signature": null,
				"is_signed": 0,
				"signature_image_url": "",
				"signature_thumb_image_url": "",
				"witness_signature_url": "",
				"witness_signature_thumb_image_url": "",
				"created_format_date": "2020\/04\/10 02:04 PM",
				"consent": {
					"id": 4,
					"consent_name": "c2",
					"consent_small_description": null,
					"consent_large_description": "xcxzbdfb",
					"added_by": "Kiranjot Kaur Gambhir",
					"last_edited_by": null,
					"status": 0,
					"created": "2020-01-07 14:15:14",
					"modified": "2020-01-07 14:15:14",
					"order_by": 2,
					"initials_per_page": 0,
					"witness_signature": 0
				}
			}],
			"procedure_prescription": [],
			"procedure_notes": [],
			"pos_invoices": null,
			"user": {
				"id": 11061,
				"clinic_id": 1,
				"user_role_id": 4,
				"is_provider": true,
				"account_id": 1937,
				"supplementary_title": null,
				"firstname": "Praveen MD",
				"lastname": "Soni",
				"email_id": "praveen.md.kiran@yopmail.com",
				"pass_code": 9102,
				"signature": "",
				"website": null,
				"contact_number_1": null,
				"contact_number_2": null,
				"contact_number_3": null,
				"contact_number_4": null,
				"address_line_1": null,
				"address_line_2": null,
				"address_line_3": null,
				"address_line_4": null,
				"pincode": null,
				"city": "Mohali",
				"state": "Punjab",
				"country": "India",
				"user_image": null,
				"status": "Active",
				"session_id": "",
				"web_session_id": "9eec033f6000826b016403da5c7f0d82",
				"last_login_ip": "2405:201:5200:676d:6c62:b16c:e09b:2f80",
				"last_login_date": "2020-05-20 11:58:10",
				"created": "2020-01-01 12:35:51",
				"modified": "2020-05-20",
				"password_flag": 0,
				"monthly_procedure_goal": 100,
				"weekly_procedure_goal": 20,
				"monthly_sales_goal": 200,
				"weekly_sales_goal": 40,
				"is_md_consent_required": true,
				"timezone": "Asia\/Kolkata",
				"appointment_color": "#E15D44",
				"vacation_mode": 0,
				"vacation_startdate": "0000-00-00",
				"vacation_enddate": "0000-00-00",
				"last_activity": "2020-02-12 17:07:03",
				"web_last_activity": "2020-05-20 12:11:18",
				"bio_name": "PS MD",
				"bio_title": "PS MD",
				"bio_description": "PS MD",
				"gender": null,
				"dob": "0000-00-00",
				"is_available_online": true,
				"md_user_id": 11061,
				"show_signature_popup": true,
				"is_dashboard_enabled": true,
				"display_order": 2,
				"is_demo": 0,
				"commission_percentage": 10,
				"receive_checkin_sms": 0,
				"app_version": "8.10.2",
				"email_id_2": null,
				"email_id_3": null,
				"cash_drawer_notification": 1,
				"super_account_id": 0,
				"super_user": 0,
				"degree_designation": "NP",
				"hourly_rate": 5,
				"procedure_steps": null,
				"state_license": null,
				"dea": null,
				"npi": null,
				"medicaid_upin": null,
				"role_name": "md",
				"user_image_url": "",
				"signature_url": "",
				"full_name": "Praveen MD Soni"
			},
			"prescription_pdf_url": null,
			"pharmacy_fax_enabled": 0,
			"pharmacy_email_enabled": 0,
			"show_questionnaires_btn": 0,
			"show_consents_btn": 0
		}
	]
}